import type { LearningArticleDocument } from "./articleTypes";

export const articleBodies: Record<string, LearningArticleDocument> = {
  "beginner-1": {
    "sourceUrl": "https://propally.co.jp/journal/lp/beginner-1/",
    "sourceTitle": "なぜ不動産投資？ 投資家が知るべき「3つのメリット」",
    "acquiredAt": "2026-10-05T07:21:40.660Z",
    "sourceTextSha256": "29a607c288ad1e10859b61b18b12891020bc851d78b0e540258f92c05137a7d8",
    "nodes": [
      {
        "tag": "p",
        "children": [
          {
            "text": "不動産投資に興味をお持ちの皆さまが、まず疑問に思うのは",
          },
          {
            "tag": "strong",
            "children": [
              {
                "text": "「なぜ株式や投資信託ではなく、不動産なのか？」",
              },
            ],
          },
          {
            "text": "ということでしょう。",
          },
          {
            "tag": "br",
            "children": [],
          },
          {
            "text": "不動産投資には、他の金融商品にはない独自の強みがあります。専門家として、まずはその代表的な「3つのメリット」を解説します。",
          },
        ],
      },
      {
        "tag": "aside",
        "role": "learn",
        "children": [
          {
            "tag": "strong",
            "children": [
              {
                "text": "学習目標",
              },
            ],
          },
          {
            "tag": "ul",
            "children": [
              {
                "tag": "li",
                "children": [
                  {
                    "text": "なぜ「不動産」に投資するのか、その独自の利点を理解する。",
                  },
                ],
              },
              {
                "tag": "li",
                "children": [
                  {
                    "text": "不動産投資が生み出す3種類のリターン（家賃収入、売却益、融資）がわかる。",
                  },
                ],
              },
            ],
          },
        ],
      },
      {
        "tag": "h3",
        "children": [
          {
            "text": "1. インカムゲイン（家賃収入）",
          },
        ],
      },
      {
        "tag": "p",
        "children": [
          {
            "text": "保有する物件を入居者に貸し出すことで得られる、継続的かつ安定的な",
          },
          {
            "tag": "strong",
            "children": [
              {
                "text": "「家賃収入」",
              },
            ],
          },
          {
            "text": "のことです。",
          },
        ],
      },
      {
        "tag": "p",
        "children": [
          {
            "text": "株価のように日々の値動きに一喜一憂する必要がなく、入居者がいる限り、毎月安定した現金を生み出してくれます。老後の年金対策や、給与とは別の",
          },
          {
            "tag": "strong",
            "children": [
              {
                "text": "「第二の収入源」",
              },
            ],
          },
          {
            "text": "として機能します。",
          },
        ],
      },
      {
        "tag": "h3",
        "children": [
          {
            "text": "2. キャピタルゲイン（売却益）",
          },
        ],
      },
      {
        "tag": "p",
        "children": [
          {
            "text": "購入した時よりも「高く売る」ことで得られる",
          },
          {
            "tag": "strong",
            "children": [
              {
                "text": "「売却益」",
              },
            ],
          },
          {
            "text": "のことです。",
          },
        ],
      },
      {
        "tag": "p",
        "children": [
          {
            "text": "景気や周辺の開発状況、市場の需要（マーケット）を見極めて売却することで、大きな利益を得られる可能性があります。ただし、家賃収入のような継続収入ではなく一回限りの利益であり、常に値上がりするとは限らない点に注意が必要です。",
          },
        ],
      },
      {
        "tag": "aside",
        "role": "product",
        "children": [
          {
            "tag": "strong",
            "children": [
              {
                "text": "プロパリー活用ポイント",
              },
            ],
          },
          {
            "tag": "p",
            "children": [
              {
                "text": "プロパリーの「成約事例検索」機能を使えば、周辺エリアの物件が過去にいくらで取引されたかを調べることができ、売却益を狙う際の参考になります。（※物件情報の入力が必要です）",
              },
            ],
          },
        ],
      },
      {
        "tag": "h3",
        "children": [
          {
            "text": "3. レバレッジ効果（融資）",
          },
        ],
      },
      {
        "tag": "p",
        "children": [
          {
            "text": "小さな力で大きなものを動かす仕組みのことです。銀行からお金を借りることで、手持ちのお金だけでは買えない高い物件を購入できます。そうすることで、少ない元手で大きな利益を得られる可能性がある、という効果を指します。",
          },
        ],
      },
      {
        "tag": "p",
        "children": [
          {
            "text": "例えば自己資金300万円でも、2,700万円の融資を組めば3,000万円の物件が購入できます。これが不動産投資の最大の強みであり、資産を効率的に拡大できる理由です。",
          },
        ],
      },
      {
        "tag": "p",
        "children": [
          {
            "text": "ただし、ローンは「借金」です。金利の上昇や空室によって返済が苦しくなるリスクも伴います。",
          },
        ],
      },
      {
        "tag": "aside",
        "role": "summary",
        "children": [
          {
            "tag": "strong",
            "children": [
              {
                "text": "学習ポイントまとめ",
              },
            ],
          },
          {
            "tag": "p",
            "children": [
              {
                "text": "不動産投資には",
              },
              {
                "tag": "br",
                "children": [],
              },
              {
                "tag": "strong",
                "children": [
                  {
                    "text": "「①毎月の家賃（インカム）」",
                  },
                  {
                    "tag": "br",
                    "children": [],
                  },
                  {
                    "text": "「②売却時の利益（キャピタル）」",
                  },
                  {
                    "tag": "br",
                    "children": [],
                  },
                  {
                    "text": "「③融資による効率化（レバレッジ）」",
                  },
                ],
              },
              {
                "tag": "br",
                "children": [],
              },
              {
                "text": "という3つのメリットがある。",
              },
            ],
          },
          {
            "tag": "p",
            "children": [
              {
                "text": "特に",
              },
              {
                "tag": "strong",
                "children": [
                  {
                    "text": "「レバレッジ」",
                  },
                ],
              },
              {
                "text": "は不動産投資特有の強力なメリットだが、リスクも伴う。",
              },
            ],
          },
        ],
      },
      {
        "tag": "p",
        "children": [
          {
            "text": "メリットを理解した次は、必ず知っておくべき「リスク」について学びましょう。",
          },
        ],
      },
      {
        "tag": "hr",
        "children": [],
      },
      {
        "tag": "p",
        "children": [],
      },
    ],
  },
  "beginner-2": {
    "sourceUrl": "https://propally.co.jp/journal/lp/beginner-2/",
    "sourceTitle": "始める前に知るべき不動産投資「5つの主要リスク」",
    "acquiredAt": "2026-10-05T07:21:40.705Z",
    "sourceTextSha256": "926f2489fa519987160ccab0f99f55c959553a61b01dc4565a3d2ed8fdb6e55e",
    "nodes": [
      {
        "tag": "p",
        "children": [
          {
            "text": "メリットもある不動産投資ですが、当然ながらリスクも存在します。 Propallyは不動産会社ではない「",
          },
          {
            "tag": "strong",
            "children": [
              {
                "text": "中立的",
              },
            ],
          },
          {
            "text": "」な立場 から、ユーザーの皆様が直面する可能性のあるリスクを隠さず解説します。",
          },
        ],
      },
      {
        "tag": "p",
        "children": [
          {
            "text": "重要なのは、",
          },
          {
            "tag": "strong",
            "children": [
              {
                "text": "リスクを「怖がること」ではなく、その正体を知り「対策を立てること」",
              },
            ],
          },
          {
            "text": "です。",
          },
        ],
      },
      {
        "tag": "aside",
        "role": "learn",
        "children": [
          {
            "tag": "strong",
            "children": [
              {
                "text": "学習目標",
              },
            ],
          },
          {
            "tag": "ul",
            "children": [
              {
                "tag": "li",
                "children": [
                  {
                    "text": "不動産投資に潜む主要なリスク（空室・家賃下落・金利・災害・流動性）を理解する。",
                  },
                ],
              },
              {
                "tag": "li",
                "children": [
                  {
                    "text": "リスクは「回避」するものではなく、「管理（コントロール）」するものであることを学ぶ。",
                  },
                ],
              },
            ],
          },
        ],
      },
      {
        "tag": "h3",
        "children": [
          {
            "text": "1. 空室リスク",
          },
        ],
      },
      {
        "tag": "p",
        "children": [
          {
            "text": "物件の入居者が決まらず、家賃収入が途絶えてしまうリスクです。",
          },
          {
            "tag": "br",
            "children": [],
          },
          {
            "text": "収入がゼロになる一方、ローンの返済や管理費は発生し続けるため、収支が一気に悪化します。",
          },
        ],
      },
      {
        "tag": "p",
        "children": [
          {
            "tag": "strong",
            "children": [
              {
                "text": "対策：",
              },
            ],
          },
        ],
      },
      {
        "tag": "ul",
        "children": [
          {
            "tag": "li",
            "children": [
              {
                "text": "賃貸需要が安定しているエリア（例：駅近、人口流入が多い）を選ぶ。",
              },
            ],
          },
          {
            "tag": "li",
            "children": [
              {
                "text": "入居者募集に強い（リーシング力が高い）管理会社を選ぶ。",
              },
            ],
          },
        ],
      },
      {
        "tag": "h3",
        "children": [
          {
            "text": "2. 家賃下落リスク",
          },
        ],
      },
      {
        "tag": "p",
        "children": [
          {
            "text": "築年数の経過や、周辺の競合物件の増加により、家賃を下げざるを得なくなるリスクです。",
          },
        ],
      },
      {
        "tag": "p",
        "children": [
          {
            "tag": "strong",
            "children": [
              {
                "text": "対策：",
              },
            ],
          },
        ],
      },
      {
        "tag": "ul",
        "children": [
          {
            "tag": "li",
            "children": [
              {
                "text": "購入時に、将来の家賃下落率を厳しめに見積もってシミュレーションする。",
              },
            ],
          },
          {
            "tag": "li",
            "children": [
              {
                "text": "適切なリフォームや設備投資を行い、物件の競争力を維持する。",
              },
            ],
          },
        ],
      },
      {
        "tag": "h3",
        "children": [
          {
            "text": "3. 金利上昇リスク",
          },
        ],
      },
      {
        "tag": "p",
        "children": [
          {
            "text": "融資（ローン）の金利が上昇し、毎月の返済額が増加するリスクです。",
          },
          {
            "tag": "br",
            "children": [],
          },
          {
            "text": "特に「変動金利」で借りている場合に影響を受けます。",
          },
        ],
      },
      {
        "tag": "p",
        "children": [
          {
            "tag": "strong",
            "children": [
              {
                "text": "対策:",
              },
            ],
          },
        ],
      },
      {
        "tag": "ul",
        "children": [
          {
            "tag": "li",
            "children": [
              {
                "text": "金利が上昇しても返済が滞らないよう、手元に現金を残しておく。",
              },
            ],
          },
          {
            "tag": "li",
            "children": [
              {
                "text": "プロパリーのシミュレーション機能で、金利が何%まで上昇したら収支が赤字になるか（損益分岐点）を把握しておく。",
              },
            ],
          },
        ],
      },
      {
        "tag": "h3",
        "children": [
          {
            "text": "4. 災害リスク",
          },
        ],
      },
      {
        "tag": "p",
        "children": [
          {
            "text": " 地震、火災、水害（台風・洪水）などによって建物が損壊し、大きな損失を被るリスクです。",
          },
        ],
      },
      {
        "tag": "p",
        "children": [
          {
            "tag": "strong",
            "children": [
              {
                "text": "対策:",
              },
            ],
          },
        ],
      },
      {
        "tag": "ul",
        "children": [
          {
            "tag": "li",
            "children": [
              {
                "text": "「火災保険」や「地震保険」に必ず加入する。",
              },
            ],
          },
          {
            "tag": "li",
            "children": [
              {
                "text": "ハザードマップを確認し、物件が立地するエリアの災害リスクを事前に把握する。",
              },
            ],
          },
        ],
      },
      {
        "tag": "h3",
        "children": [
          {
            "text": "5. 流動性リスク",
          },
        ],
      },
      {
        "tag": "p",
        "children": [
          {
            "text": "不動産は「売りたい」と思っても、株式のように即日で現金化できないリスクです。買い手が見つかるまでに数ヶ月かかることもあります。",
          },
        ],
      },
      {
        "tag": "p",
        "children": [
          {
            "tag": "strong",
            "children": [
              {
                "text": "対策:",
              },
            ],
          },
        ],
      },
      {
        "tag": "ul",
        "children": [
          {
            "tag": "li",
            "children": [
              {
                "text": "常に「売りやすい」（＝買い手がつきやすい）物件を選ぶことを意識する。",
              },
            ],
          },
          {
            "tag": "li",
            "children": [
              {
                "text": "緊急時に備え、不動産以外の現金・預金もある程度確保しておく。",
              },
            ],
          },
        ],
      },
      {
        "tag": "aside",
        "role": "summary",
        "children": [
          {
            "tag": "strong",
            "children": [
              {
                "text": "学習ポイントまとめ",
              },
            ],
          },
          {
            "tag": "p",
            "children": [
              {
                "text": "不動産投資には、",
              },
              {
                "tag": "br",
                "children": [],
              },
              {
                "text": "①",
              },
              {
                "tag": "strong",
                "children": [
                  {
                    "text": "「空室」",
                  },
                  {
                    "tag": "br",
                    "children": [],
                  },
                  {
                    "text": "②「家賃下落」",
                  },
                  {
                    "tag": "br",
                    "children": [],
                  },
                  {
                    "text": "③「金利上昇」",
                  },
                  {
                    "tag": "br",
                    "children": [],
                  },
                  {
                    "text": "④「災害」",
                  },
                  {
                    "tag": "br",
                    "children": [],
                  },
                  {
                    "text": "⑤「流動性」",
                  },
                ],
              },
              {
                "tag": "br",
                "children": [],
              },
              {
                "text": "という主要なリスクがある。",
              },
            ],
          },
          {
            "tag": "p",
            "children": [
              {
                "text": "リスクはゼロにはできないが、事前の",
              },
              {
                "tag": "strong",
                "children": [
                  {
                    "text": "「シミュレーション」",
                  },
                ],
              },
              {
                "text": "と",
              },
              {
                "tag": "strong",
                "children": [
                  {
                    "text": "「対策」",
                  },
                ],
              },
              {
                "text": "（保険、物件選定、管理）によってコントロールすることが可能である。",
              },
            ],
          },
        ],
      },
      {
        "tag": "p",
        "children": [
          {
            "text": " メリットとリスクを学んだ次は、不動産投資の「検討→購入→管理→売却」 という全体の流れを掴みましょう。",
          },
        ],
      },
      {
        "tag": "hr",
        "children": [],
      },
    ],
  },
  "beginner-3": {
    "sourceUrl": "https://propally.co.jp/journal/lp/beginner-3/",
    "sourceTitle": "投資の全ステップ解説（検討～売却）",
    "acquiredAt": "2026-10-05T07:21:40.714Z",
    "sourceTextSha256": "d29723441921ef341695891105de7725b3a64072b419d58a22beda1fc7d4cf8e",
    "nodes": [
      {
        "tag": "p",
        "children": [
          {
            "text": "不動産投資は、物件を買って終わりではありません。むしろ、",
          },
          {
            "tag": "strong",
            "children": [
              {
                "text": "購入後の「管理（運営）」や、将来の「売却（出口戦略）」こそが、投資成果を左右する重要なポイント",
              },
            ],
          },
          {
            "text": "です。",
          },
        ],
      },
      {
        "tag": "p",
        "children": [
          {
            "text": "投資家が歩むプロセスは、大きく分けて以下の4つのステップで構成されます。",
          },
        ],
      },
      {
        "tag": "aside",
        "role": "learn",
        "children": [
          {
            "tag": "strong",
            "children": [
              {
                "text": "学習目標",
              },
            ],
          },
          {
            "tag": "ul",
            "children": [
              {
                "tag": "li",
                "children": [
                  {
                    "text": "不動産投資が「買って終わり」ではなく、「検討→購入→管理→売却」という長期的なプロセスであることを理解する。",
                  },
                ],
              },
              {
                "tag": "li",
                "children": [
                  {
                    "text": "投資の各フェーズ（段階）で、どのようなタスクが発生するかを把握する。",
                  },
                ],
              },
            ],
          },
        ],
      },
      {
        "tag": "h3",
        "children": [
          {
            "text": "1. 検討フェーズ：『学ぶ』『相談する』",
          },
        ],
      },
      {
        "tag": "p",
        "children": [
          {
            "text": "まず、不動産投資の基礎知識（リスク、利回り、融資など）を学びます。",
          },
          {
            "tag": "br",
            "children": [],
          },
          {
            "text": "次は信頼できるパートナー（不動産のプロ）を探します。融資の相談や、図面だけでは分からない物件の詳細情報をヒアリングし、専門的な助言を受けるパートナーを選定します。不動産投資において一番重要な工程です。",
          },
        ],
      },
      {
        "tag": "aside",
        "role": "product",
        "children": [
          {
            "tag": "strong",
            "children": [
              {
                "text": "プロパリー活用ポイント",
              },
            ],
          },
          {
            "tag": "p",
            "children": [
              {
                "text": "知識を付けたい方は、プロパリースタディーサポートで学びましょう。",
              },
            ],
          },
          {
            "tag": "p",
            "children": [
              {
                "text": "また、不動産投資のプロに直接話を聞いてみることも重要です。プロパリーでは、プロフェッショナルを厳しく審査していますので、安心して話を聞くことができます。",
              },
            ],
          },
        ],
      },
      {
        "tag": "h3",
        "children": [
          {
            "text": "2. 購入フェーズ：『物件を探す』『試算する』『決断する』",
          },
        ],
      },
      {
        "tag": "p",
        "children": [
          {
            "text": "良いパートナーと出会え、物件情報を収集し、気になる物件が見つかったら、それが本当に利益を生むのかをシミュレーション（試算）します。 特に、表面的な利回りだけでなく、経費やローン返済を考慮した詳細な収支計画を立てることが、この段階で最も重要です。シミュレーションで「買うべき」と判断したら、最終的な購入の意思決定をします。",
          },
        ],
      },
      {
        "tag": "aside",
        "role": "product",
        "children": [
          {
            "tag": "strong",
            "children": [
              {
                "text": "プロパリー活用ポイント",
              },
            ],
          },
          {
            "tag": "p",
            "children": [
              {
                "text": "プロパリーでは、保有していない物件だけでなく、気になる物件の収支を詳細にシミュレーションすることができます。",
              },
            ],
          },
          {
            "tag": "p",
            "children": [
              {
                "text": "※検討物件の登録が必要です",
              },
            ],
          },
        ],
      },
      {
        "tag": "h3",
        "children": [
          {
            "text": "3. 管理（運営）フェーズ：『運営する』『記録する』",
          },
        ],
      },
      {
        "tag": "p",
        "children": [
          {
            "text": "物件の引き渡しを受けたら、いよいよオーナーとして「運営」が始まります。入居者募集、家賃の回収、クレーム対応、退去時の原状回復などを管理会社と連携しながら行います。 また、毎月の家賃収入や経費（管理費、修繕積立金、ローン返済など）を正確に記録し、収支を把握することが確定申告のためにも不可欠です。",
          },
        ],
      },
      {
        "tag": "aside",
        "role": "product",
        "children": [
          {
            "tag": "strong",
            "children": [
              {
                "text": "プロパリー活用ポイント",
              },
            ],
          },
          {
            "tag": "p",
            "children": [
              {
                "text": "プロパリーでは、保有物件を登録することで保有物件の毎月の収支をカンタンに記録・管理できます。",
              },
            ],
          },
        ],
      },
      {
        "tag": "h3",
        "children": [
          {
            "text": "4. 売却（出口）フェーズ：『査定する』『売る』",
          },
        ],
      },
      {
        "tag": "p",
        "children": [
          {
            "text": "投資の「出口戦略」です。保有物件の価値がいくらになっているか、市場価格（相場）を把握します。金利の動向やご自身のライフプランの変化を踏まえ、最適なタイミングで売却し、投資の利益を確定させます。",
          },
        ],
      },
      {
        "tag": "aside",
        "role": "summary",
        "children": [
          {
            "tag": "strong",
            "children": [
              {
                "text": "学習ポイントまとめ",
              },
            ],
          },
          {
            "tag": "p",
            "children": [
              {
                "text": "不動産投資は",
              },
              {
                "tag": "strong",
                "children": [
                  {
                    "text": "「検討・購入・管理・売却」",
                  },
                ],
              },
              {
                "text": "の4つのフェーズで構成される長期的な事業である。",
              },
            ],
          },
          {
            "tag": "p",
            "children": [
              {
                "text": "各フェーズで「やるべきこと」を理解し、計画的に進めることが成功の鍵となる。",
              },
            ],
          },
        ],
      },
      {
        "tag": "p",
        "children": [
          {
            "text": "全体像を掴んだところで、次はいよいよ不動産投資で最も重要な指標、「利回り」の計算について深く学んでいきましょう。",
          },
        ],
      },
      {
        "tag": "hr",
        "children": [],
      },
    ],
  },
  "beginner-4": {
    "sourceUrl": "https://propally.co.jp/journal/lp/beginner-4/",
    "sourceTitle": "【最重要】”利回り”の罠：実質利回りを見抜く",
    "acquiredAt": "2026-10-05T07:21:40.884Z",
    "sourceTextSha256": "00a6ef1fac669b685f6f50e59d2f3e657dd608f8a65371b5da4a0d603e9e0b07",
    "nodes": [
      {
        "tag": "p",
        "children": [
          {
            "text": "不動産投資の物件広告で、最も目立つ数字が「利回り」です。しかし、この数字には注意すべき「罠」が潜んでいます。",
          },
        ],
      },
      {
        "tag": "p",
        "children": [
          {
            "text": "利回りには、大きく分けて2種類あります。",
          },
        ],
      },
      {
        "tag": "aside",
        "role": "learn",
        "children": [
          {
            "tag": "strong",
            "children": [
              {
                "text": "学習目標",
              },
            ],
          },
          {
            "tag": "ul",
            "children": [
              {
                "tag": "li",
                "children": [
                  {
                    "text": "「表面利回り」と「実質利回り」の違いを明確に理解する。",
                  },
                ],
              },
              {
                "tag": "li",
                "children": [
                  {
                    "text": "なぜ「表面利回り」だけを見て投資を判断するのが危険なのか、その理由（諸経費の存在）を学ぶ。",
                  },
                ],
              },
            ],
          },
        ],
      },
      {
        "tag": "h3",
        "children": [
          {
            "tag": "strong",
            "children": [
              {
                "text": "1. 表面利回り（グロス利回り）",
              },
            ],
          },
        ],
      },
      {
        "tag": "p",
        "children": [
          {
            "text": "物件価格に対する「年間の家賃収入」の割合です。",
          },
        ],
      },
      {
        "tag": "p",
        "children": [
          {
            "tag": "strong",
            "children": [
              {
                "text": "年間家賃収入 ÷ 物件価格 × 100",
              },
            ],
          },
        ],
        "role": "formula",
      },
      {
        "tag": "p",
        "children": [
          {
            "text": "計算が簡単なため、広告や物件概要で最も一般的に使われますが、",
          },
          {
            "tag": "br",
            "children": [],
          },
          {
            "text": "この数字には、不動産を運営するために",
          },
          {
            "tag": "strong",
            "children": [
              {
                "text": "必要な経費（コスト）が一切含まれていません。",
              },
            ],
          },
        ],
      },
      {
        "tag": "h3",
        "children": [
          {
            "tag": "strong",
            "children": [
              {
                "tag": "strong",
                "children": [
                  {
                    "text": "2. 実質利回り（ネット利回り）",
                  },
                ],
              },
            ],
          },
        ],
      },
      {
        "tag": "p",
        "children": [
          {
            "text": "物件価格に対する「経費を差し引いた後の実質的な家賃収入」の割合です。",
          },
        ],
      },
      {
        "tag": "p",
        "children": [
          {
            "tag": "strong",
            "children": [
              {
                "text": " (年間家賃収入 － 年間諸経費) ÷ 物件価格 × 100",
              },
            ],
          },
        ],
        "role": "formula",
      },
      {
        "tag": "p",
        "children": [
          {
            "text": "投資家が",
          },
          {
            "text": "「",
          },
          {
            "tag": "strong",
            "children": [
              {
                "text": "実際に手元にいくら残るのか",
              },
            ],
          },
          {
            "text": "」",
          },
          {
            "text": "を測るための、より現実に近い利回りです。",
          },
        ],
      },
      {
        "tag": "h3",
        "children": [
          {
            "text": "3. ",
          },
          {
            "tag": "strong",
            "children": [
              {
                "tag": "strong",
                "children": [
                  {
                    "tag": "strong",
                    "children": [
                      {
                        "text": "なぜ実質利回りが重要なのか？",
                      },
                    ],
                  },
                ],
              },
            ],
          },
        ],
      },
      {
        "tag": "p",
        "children": [
          {
            "text": "表面利回りが同じ「10%」の物件でも、片方は経費が安く（実質利回り8%）、もう片方は経費が高く（実質利回り4%）なるケースは珍しくありません。",
          },
        ],
      },
      {
        "tag": "h3",
        "children": [
          {
            "text": "4. ",
          },
          {
            "tag": "strong",
            "children": [
              {
                "text": "不動産運営にかかる「年間諸経費」の例",
              },
            ],
          },
        ],
      },
      {
        "tag": "ul",
        "children": [
          {
            "tag": "li",
            "children": [
              {
                "text": "管理費（マンションの場合）",
              },
            ],
          },
          {
            "tag": "li",
            "children": [
              {
                "text": "修繕積立金（マンションの場合）",
              },
            ],
          },
          {
            "tag": "li",
            "children": [
              {
                "text": "固定資産税・都市計画税（毎年必ずかかる税金）",
              },
            ],
          },
          {
            "tag": "li",
            "children": [
              {
                "text": "賃貸管理会社への管理手数料（家賃の約5%が相場）",
              },
            ],
          },
          {
            "tag": "li",
            "children": [
              {
                "text": "火災保険料、地震保険料",
              },
            ],
          },
          {
            "tag": "li",
            "children": [
              {
                "text": "（一棟ものの場合）共用部の水道光熱費、清掃費",
              },
            ],
          },
        ],
      },
      {
        "tag": "p",
        "children": [
          {
            "text": "これらの経費は、物件の構造（例：RC造）、築年数、管理会社のプランによって大きく異なります。 表面利回りだけで「こちらの方が高利回りだ」と飛びつくと、購入後に「経費が高すぎて、思ったより手元にお金が残らない」という失敗に繋がります。",
          },
        ],
      },
      {
        "tag": "aside",
        "role": "product",
        "children": [
          {
            "tag": "strong",
            "children": [
              {
                "text": "プロパリー活用ポイント",
              },
            ],
          },
          {
            "tag": "p",
            "children": [
              {
                "text": "この複雑な「実質利回り」の計算は、プロパリーが最も得意とするところです。",
              },
              {
                "tag": "br",
                "children": [],
              },
              {
                "text": "物件情報を入力するだけで、経費を考慮した詳細な収支を自動で計算可能です。",
              },
            ],
          },
        ],
      },
      {
        "tag": "aside",
        "role": "summary",
        "children": [
          {
            "tag": "strong",
            "children": [
              {
                "text": "学習ポイントまとめ",
              },
            ],
          },
          {
            "tag": "p",
            "children": [
              {
                "tag": "strong",
                "children": [
                  {
                    "text": "「表面利回り」",
                  },
                ],
              },
              {
                "text": "は物件のポテンシャル（売上高）を見る指標。",
              },
            ],
          },
          {
            "tag": "p",
            "children": [
              {
                "tag": "strong",
                "children": [
                  {
                    "text": "「実質利回り」",
                  },
                ],
              },
              {
                "text": "は投資の収益性（営業利益）を見る指標。",
              },
            ],
          },
          {
            "tag": "p",
            "children": [
              {
                "text": "不動産投資の判断は、必ず",
              },
              {
                "tag": "strong",
                "children": [
                  {
                    "text": "「実質利回り」",
                  },
                ],
              },
              {
                "text": "で行うクセをつける。",
              },
            ],
          },
        ],
      },
      {
        "tag": "p",
        "children": [
          {
            "text": "利回りの計算方法を学んだ次は、物件の「種類（区分・一棟・戸建て）」ごとの特徴を学び、ご自身に合った投資スタイルを探しましょう。",
          },
        ],
      },
      {
        "tag": "hr",
        "children": [],
      },
      {
        "tag": "p",
        "children": [],
      },
    ],
  },
  "beginner-5": {
    "sourceUrl": "https://propally.co.jp/journal/lp/beginner-5/",
    "sourceTitle": "物件種別（区分・一棟・戸建て）徹底比較",
    "acquiredAt": "2026-10-05T07:21:40.841Z",
    "sourceTextSha256": "01d0ebbb16354e5fd7e7889c62dfc5e2e72bf9c691fb7c2c5e3fbb6a4baab94c",
    "nodes": [
      {
        "tag": "p",
        "children": [
          {
            "text": "不動産投資と一口に言っても、その対象物件には",
          },
          {
            "tag": "strong",
            "children": [
              {
                "text": "大きく分けて3つの種類",
              },
            ],
          },
          {
            "text": "があります。それぞれ特徴が全く異なるため、ご自身の戦略に合ったものを選びましょう。",
          },
        ],
      },
      {
        "tag": "aside",
        "role": "learn",
        "children": [
          {
            "tag": "strong",
            "children": [
              {
                "text": "学習目標",
              },
            ],
          },
          {
            "tag": "ul",
            "children": [
              {
                "tag": "li",
                "children": [
                  {
                    "tag": "strong",
                    "children": [
                      {
                        "text": "「区分」「一棟」「戸建て」",
                      },
                    ],
                  },
                  {
                    "text": "それぞれのメリットとデメリットを理解する。",
                  },
                ],
              },
              {
                "tag": "li",
                "children": [
                  {
                    "text": "自身の資金力や投資スタイル（かけられる手間、リスク許容度）に合った物件種別を考えるきっかけにする。",
                  },
                ],
              },
            ],
          },
        ],
      },
      {
        "tag": "div",
        "role": "comparison",
        "children": [
          {
            "tag": "section",
            "children": [
              {
                "tag": "h3",
                "children": [
                  {
                    "text": "1. 区分マンション（1部屋）",
                  },
                ],
              },
              {
                "tag": "p",
                "children": [
                  {
                    "text": "マンションやアパートの「1部屋」単位で購入する、最も一般的な投資対象です。",
                  },
                ],
              },
              {
                "tag": "aside",
                "role": "advantages",
                "children": [
                  {
                    "tag": "p",
                    "children": [
                      {
                        "tag": "strong",
                        "children": [
                          {
                            "text": "メリット：",
                          },
                        ],
                      },
                    ],
                  },
                  {
                    "tag": "ul",
                    "children": [
                      {
                        "tag": "li",
                        "children": [
                          {
                            "text": "一棟ものに比べ価格が安く、数百万円〜と比較的少額から始められます。",
                          },
                        ],
                      },
                      {
                        "tag": "li",
                        "children": [
                          {
                            "text": "建物の共用部（エントランス、廊下など）の管理は管理組合（と管理会社）が行うため、オーナーの手間が少ないです。",
                          },
                        ],
                      },
                      {
                        "tag": "li",
                        "children": [
                          {
                            "text": "比較的「売りやすく」、現金化しやすい傾向があります。",
                          },
                        ],
                      },
                    ],
                  },
                ],
              },
              {
                "tag": "aside",
                "role": "risks",
                "children": [
                  {
                    "tag": "p",
                    "children": [
                      {
                        "tag": "strong",
                        "children": [
                          {
                            "text": "デメリット：",
                          },
                        ],
                      },
                    ],
                  },
                  {
                    "tag": "ul",
                    "children": [
                      {
                        "tag": "li",
                        "children": [
                          {
                            "text": "リスクが少ない分、毎月の収入も控えめです",
                          },
                        ],
                      },
                      {
                        "tag": "li",
                        "children": [
                          {
                            "text": "管理規約（ペット不可、リフォーム制限など）があり、自由な運営がしづらい場合があります。",
                          },
                        ],
                      },
                      {
                        "tag": "li",
                        "children": [
                          {
                            "text": "土地の持分が小さいため、土地の資産価値はあまり期待できません。",
                          },
                        ],
                      },
                    ],
                  },
                ],
              },
            ],
          },
          {
            "tag": "section",
            "children": [
              {
                "tag": "h3",
                "children": [
                  {
                    "tag": "strong",
                    "children": [
                      {
                        "text": "2. 一棟アパート・マンション（建物まるごと）",
                      },
                    ],
                  },
                ],
              },
              {
                "tag": "p",
                "children": [
                  {
                    "text": "アパートやマンションを「建物ごと」購入します。",
                  },
                ],
              },
              {
                "tag": "aside",
                "role": "advantages",
                "children": [
                  {
                    "tag": "p",
                    "children": [
                      {
                        "tag": "strong",
                        "children": [
                          {
                            "text": "メリット：",
                          },
                        ],
                      },
                    ],
                  },
                  {
                    "tag": "ul",
                    "children": [
                      {
                        "tag": "li",
                        "children": [
                          {
                            "text": "部屋数が多いため、満室時の家賃収入は大きくなります。",
                          },
                        ],
                      },
                      {
                        "tag": "li",
                        "children": [
                          {
                            "text": "建物だけでなく「土地」もすべて自分のものになります。",
                          },
                        ],
                      },
                      {
                        "tag": "li",
                        "children": [
                          {
                            "text": "リフォームや修繕計画、管理方法などをすべて自分でコントロールできます。",
                          },
                        ],
                      },
                    ],
                  },
                ],
              },
              {
                "tag": "aside",
                "role": "risks",
                "children": [
                  {
                    "tag": "p",
                    "children": [
                      {
                        "tag": "strong",
                        "children": [
                          {
                            "text": "デメリット：",
                          },
                        ],
                      },
                    ],
                  },
                  {
                    "tag": "ul",
                    "children": [
                      {
                        "tag": "li",
                        "children": [
                          {
                            "text": "購入価格が高額になり、融資のハードル（一定の高年収、物件価格の2割ほどの自己資金等）も上がります。",
                          },
                        ],
                      },
                      {
                        "tag": "li",
                        "children": [
                          {
                            "text": "建物の維持管理（清掃、法定点検、大規模修繕）をすべて自分で行う必要があり、手間とコストがかかります。",
                          },
                        ],
                      },
                      {
                        "tag": "li",
                        "children": [
                          {
                            "text": "エリアによっては、全室が同時に空室になるリスクもあります。",
                          },
                        ],
                      },
                    ],
                  },
                ],
              },
            ],
          },
          {
            "tag": "section",
            "children": [
              {
                "tag": "h3",
                "children": [
                  {
                    "tag": "strong",
                    "children": [
                      {
                        "tag": "strong",
                        "children": [
                          {
                            "text": "3. 戸建て（1軒家）",
                          },
                        ],
                      },
                    ],
                  },
                ],
              },
              {
                "tag": "p",
                "children": [
                  {
                    "text": "1軒家を購入し、賃貸に出します。",
                  },
                ],
              },
              {
                "tag": "aside",
                "role": "advantages",
                "children": [
                  {
                    "tag": "p",
                    "children": [
                      {
                        "tag": "strong",
                        "children": [
                          {
                            "text": "メリット：",
                          },
                        ],
                      },
                    ],
                  },
                  {
                    "tag": "ul",
                    "children": [
                      {
                        "tag": "li",
                        "children": [
                          {
                            "text": "ファミリー層が多く、一度入居すると長期間住んでくれる（家賃収入が安定する）傾向があります。",
                          },
                        ],
                      },
                      {
                        "tag": "li",
                        "children": [
                          {
                            "text": "一棟ものと同様に「土地」が資産として残ります。",
                          },
                        ],
                      },
                    ],
                  },
                ],
              },
              {
                "tag": "aside",
                "role": "risks",
                "children": [
                  {
                    "tag": "p",
                    "children": [
                      {
                        "tag": "strong",
                        "children": [
                          {
                            "text": "デメリット：",
                          },
                        ],
                      },
                    ],
                  },
                  {
                    "tag": "ul",
                    "children": [
                      {
                        "tag": "li",
                        "children": [
                          {
                            "text": "区分マンションに比べると流動性（売りやすさ）は低い傾向があります。",
                          },
                        ],
                      },
                      {
                        "tag": "li",
                        "children": [
                          {
                            "text": "修繕（屋根、外壁など）が発生した場合、費用は全額オーナー負担となります。",
                          },
                        ],
                      },
                      {
                        "tag": "li",
                        "children": [
                          {
                            "text": "賃貸需要がエリア（特に郊外）によって大きく左右されます。",
                          },
                        ],
                      },
                    ],
                  },
                ],
              },
            ],
          },
        ],
      },
      {
        "tag": "aside",
        "role": "product",
        "children": [
          {
            "tag": "strong",
            "children": [
              {
                "text": "プロパリー活用ポイント",
              },
            ],
          },
          {
            "tag": "p",
            "children": [
              {
                "text": "どの物件種別を選ぶにせよ、",
              },
              {
                "tag": "strong",
                "children": [
                  {
                    "text": "「実質利回り」の計算",
                  },
                ],
              },
              {
                "text": "は不可欠です。",
              },
            ],
          },
          {
            "tag": "p",
            "children": [
              {
                "text": "種別ごとに異なる経費も、プロパリーなら詳細に設定してシミュレーションできます。",
              },
            ],
          },
          {
            "tag": "p",
            "children": [
              {
                "text": "※物件の登録が必要です",
              },
            ],
          },
        ],
      },
      {
        "tag": "hr",
        "children": [],
      },
      {
        "tag": "aside",
        "role": "summary",
        "children": [
          {
            "tag": "strong",
            "children": [
              {
                "text": "学習ポイントまとめ",
              },
            ],
          },
          {
            "tag": "ul",
            "children": [
              {
                "tag": "li",
                "children": [
                  {
                    "text": "物件種別に絶対的な「正解」はない。",
                  },
                ],
              },
              {
                "tag": "li",
                "children": [
                  {
                    "text": "ご自身の",
                  },
                  {
                    "tag": "strong",
                    "children": [
                      {
                        "text": "「資金力」「かけられる手間」「リスク許容度」",
                      },
                    ],
                  },
                  {
                    "text": "を基に選ぶことが重要。",
                  },
                ],
              },
              {
                "tag": "li",
                "children": [
                  {
                    "text": "初心者は比較的価格が安く、管理の手間が少ない",
                  },
                  {
                    "tag": "strong",
                    "children": [
                      {
                        "text": "「区分マンション」",
                      },
                    ],
                  },
                  {
                    "text": "から始めるケースが多い。",
                  },
                ],
              },
            ],
          },
        ],
      },
      {
        "tag": "p",
        "children": [
          {
            "text": "物件の「種類」を学んだ次は、物件の「構造（木造、RC造など）」と、それが融資や税金にどう影響するかを学びましょう。",
          },
        ],
      },
      {
        "tag": "hr",
        "children": [],
      },
    ],
  },
  "beginner-6": {
    "sourceUrl": "https://propally.co.jp/journal/lp/beginner-6/",
    "sourceTitle": "構造（木造/RC/SRC）と「法定耐用年数」の違い",
    "acquiredAt": "2026-10-05T07:21:40.880Z",
    "sourceTextSha256": "c12d7766bba43f089b7c1567e5351ac4bcb9dd689b0901cc9e1e073eb2e3c67c",
    "nodes": [
      {
        "tag": "p",
        "children": [
          {
            "text": "物件情報を見ると",
          },
          {
            "text": "、",
          },
          {
            "tag": "strong",
            "children": [
              {
                "text": "「構造：RC造」",
              },
            ],
          },
          {
            "text": "や",
          },
          {
            "tag": "strong",
            "children": [
              {
                "text": "「築年数：10年」",
              },
            ],
          },
          {
            "text": "といった記載があります。",
          },
          {
            "tag": "br",
            "children": [],
          },
          {
            "text": "この「構造」は、単に建物の頑丈さを示すだけでなく、",
          },
          {
            "tag": "strong",
            "children": [
              {
                "text": "不動産投資の「融資」と「税金」に大きな影響を与えます。",
              },
            ],
          },
        ],
      },
      {
        "tag": "aside",
        "role": "learn",
        "children": [
          {
            "tag": "strong",
            "children": [
              {
                "text": "学習目標",
              },
            ],
          },
          {
            "tag": "ul",
            "children": [
              {
                "tag": "li",
                "children": [
                  {
                    "text": "木造、RC造などの主な構造の特徴を理解する。",
                  },
                ],
              },
              {
                "tag": "li",
                "children": [
                  {
                    "text": "「法定耐用年数」が「融資期間」と「税金（減価償却）」にどう影響するかを学ぶ。",
                  },
                ],
              },
            ],
          },
        ],
      },
      {
        "tag": "h3",
        "children": [
          {
            "tag": "strong",
            "children": [
              {
                "text": "1. 主な建物の構造",
              },
            ],
          },
        ],
      },
      {
        "tag": "p",
        "children": [
          {
            "tag": "strong",
            "children": [
              {
                "text": "W造（木造）:",
              },
            ],
          },
          {
            "text": " 主に戸建てや低層アパートで使用されます。建築コストは安い傾向があります。",
          },
        ],
      },
      {
        "tag": "p",
        "children": [
          {
            "tag": "strong",
            "children": [
              {
                "text": "S造（鉄骨造）:",
              },
            ],
          },
          {
            "text": " アパートや小規模なマンション、ビルで使用されます。鉄骨の厚みによって「軽量鉄骨」と「重量鉄骨」に分かれます。",
          },
        ],
      },
      {
        "tag": "p",
        "children": [
          {
            "tag": "strong",
            "children": [
              {
                "text": "RC造（鉄筋コンクリート造）:",
              },
            ],
          },
          {
            "text": " 耐久性・耐火性・防音性に優れ、中高層のマンションで最も一般的に使われます。",
          },
        ],
      },
      {
        "tag": "p",
        "children": [
          {
            "tag": "strong",
            "children": [
              {
                "text": "SRC造（鉄骨鉄筋コンクリート造）:",
              },
            ],
          },
          {
            "text": " RC造の芯にさらに鉄骨を入れた構造で、最も頑丈です。タワーマンションなど大規模な建物で使われます。",
          },
        ],
      },
      {
        "tag": "h3",
        "children": [
          {
            "tag": "strong",
            "children": [
              {
                "tag": "strong",
                "children": [
                  {
                    "text": "2. 最重要知識：「法定耐用年数」",
                  },
                ],
              },
            ],
          },
        ],
      },
      {
        "tag": "p",
        "children": [
          {
            "text": "ここが本題です。税法上、建物はその構造ごとに「資産として価値がある期間」が決められており、これを",
          },
          {
            "tag": "strong",
            "children": [
              {
                "text": "法定耐用年数",
              },
            ],
          },
          {
            "text": "と呼びます。",
          },
        ],
      },
      {
        "tag": "p",
        "children": [
          {
            "text": "木造： ",
          },
          {
            "tag": "strong",
            "children": [
              {
                "text": "22年",
              },
            ],
          },
        ],
      },
      {
        "tag": "p",
        "children": [
          {
            "text": "軽量鉄骨造（骨格材の厚みによる）： ",
          },
          {
            "tag": "strong",
            "children": [
              {
                "text": "19年または27年",
              },
            ],
          },
        ],
      },
      {
        "tag": "p",
        "children": [
          {
            "text": "重量鉄骨造（骨格材の厚みによる）： ",
          },
          {
            "tag": "strong",
            "children": [
              {
                "text": "34年",
              },
            ],
          },
        ],
      },
      {
        "tag": "p",
        "children": [
          {
            "text": "RC造・SRC造： ",
          },
          {
            "tag": "strong",
            "children": [
              {
                "text": "47年",
              },
            ],
          },
        ],
      },
      {
        "tag": "p",
        "children": [
          {
            "text": "これは「建物の寿命」ではありません。RC造の建物が47年で住めなくなるわけではなく、あくまで",
          },
          {
            "tag": "strong",
            "children": [
              {
                "text": "税金や融資の計算で使われる「法的なモノサシ」",
              },
            ],
          },
          {
            "text": "です。",
          },
        ],
      },
      {
        "tag": "h3",
        "children": [
          {
            "text": "3.",
          },
          {
            "tag": "strong",
            "children": [
              {
                "tag": "strong",
                "children": [
                  {
                    "tag": "strong",
                    "children": [
                      {
                        "text": "「法定耐用年数」が投資に与える2つの影響",
                      },
                    ],
                  },
                ],
              },
            ],
          },
        ],
      },
      {
        "tag": "p",
        "children": [
          {
            "tag": "strong",
            "children": [
              {
                "text": "影響①：融資期間（ローン返済）",
              },
            ],
          },
        ],
      },
      {
        "tag": "p",
        "children": [
          {
            "text": "ローン期間が短いと、毎月の返済額が大きくなり、キャッシュフロー（手残り）が悪化します。",
          },
        ],
      },
      {
        "tag": "p",
        "children": [
          {
            "text": "多くの金融機関は、ローンの返済期間を",
          },
        ],
      },
      {
        "tag": "p",
        "children": [
          {
            "text": "「",
          },
          {
            "tag": "strong",
            "children": [
              {
                "text": "（法定耐用年数）－（築年数）",
              },
            ],
          },
          {
            "text": "」",
          },
        ],
        "role": "formula",
      },
      {
        "tag": "p",
        "children": [
          {
            "text": "の範囲内で設定します。",
          },
        ],
      },
      {
        "tag": "p",
        "children": [
          {
            "tag": "strong",
            "children": [
              {
                "text": "例：RC造（耐用年数47年）で築10年の物件",
              },
            ],
          },
          {
            "tag": "br",
            "children": [],
          },
          {
            "text": "→ 47年 － 10年 ＝ ",
          },
          {
            "tag": "strong",
            "children": [
              {
                "text": "最長37年",
              },
            ],
          },
          {
            "text": "のローンが組める可能性がある。",
          },
        ],
      },
      {
        "tag": "p",
        "children": [
          {
            "tag": "strong",
            "children": [
              {
                "text": "例：木造（耐用年数22年）で築10年の物件",
              },
            ],
          },
          {
            "tag": "br",
            "children": [],
          },
          {
            "text": "→ 22年 － 10年 ＝ ",
          },
          {
            "tag": "strong",
            "children": [
              {
                "text": "最長12年",
              },
            ],
          },
          {
            "text": "のローンしか組めない可能性がある。",
          },
        ],
      },
      {
        "tag": "p",
        "children": [
          {
            "text": "ローン期間が短いと、毎月の返済額が大きくなり、キャッシュフロー（手残り）が悪化します。",
          },
        ],
      },
      {
        "tag": "p",
        "children": [
          {
            "tag": "strong",
            "children": [
              {
                "tag": "strong",
                "children": [
                  {
                    "text": "影響②：税金（減価償却）",
                  },
                ],
              },
            ],
          },
        ],
      },
      {
        "tag": "p",
        "children": [
          {
            "text": "不動産投資では、建物の購入費用を法定耐用年数で分割し、毎年「",
          },
          {
            "tag": "strong",
            "children": [
              {
                "text": "減価償却費",
              },
            ],
          },
          {
            "text": "」として経費計上できます。",
          },
        ],
      },
      {
        "tag": "p",
        "children": [
          {
            "text": "例：",
          },
          {
            "tag": "strong",
            "children": [
              {
                "text": "木造（22年）",
              },
            ],
          },
          {
            "text": "は、",
          },
          {
            "tag": "strong",
            "children": [
              {
                "text": "RC造（47年）",
              },
            ],
          },
          {
            "text": "よりも、毎年「多く」経費として計上できます。（短い期間で費用化するため）",
          },
        ],
      },
      {
        "tag": "p",
        "children": [
          {
            "text": "この「減価償却費」は、実際には支出していない（お金が出ていかない）経費のため、うまく活用すると",
          },
          {
            "tag": "strong",
            "children": [
              {
                "text": "税金（所得税・住民税）を抑える効果",
              },
            ],
          },
          {
            "text": "（節税効果）があります。",
          },
        ],
      },
      {
        "tag": "hr",
        "children": [],
      },
      {
        "tag": "aside",
        "role": "summary",
        "children": [
          {
            "tag": "strong",
            "children": [
              {
                "text": "学習ポイントまとめ",
              },
            ],
          },
          {
            "tag": "ul",
            "children": [
              {
                "tag": "li",
                "children": [
                  {
                    "text": "建物の",
                  },
                  {
                    "tag": "strong",
                    "children": [
                      {
                        "text": "「構造」",
                      },
                    ],
                  },
                  {
                    "text": "によって、税法上の",
                  },
                  {
                    "tag": "strong",
                    "children": [
                      {
                        "text": "「法定耐用年数」",
                      },
                    ],
                  },
                  {
                    "text": "が決まっている。",
                  },
                ],
              },
              {
                "tag": "li",
                "children": [
                  {
                    "tag": "strong",
                    "children": [
                      {
                        "text": "「法定耐用年数」",
                      },
                    ],
                  },
                  {
                    "text": "は、金融機関が",
                  },
                  {
                    "tag": "strong",
                    "children": [
                      {
                        "text": "「融資期間」",
                      },
                    ],
                  },
                  {
                    "text": "を決める際の重要な基準となる。",
                  },
                ],
              },
              {
                "tag": "li",
                "children": [
                  {
                    "tag": "strong",
                    "children": [
                      {
                        "text": "「法定耐用年数」",
                      },
                    ],
                  },
                  {
                    "text": "は、税金計算上の",
                  },
                  {
                    "tag": "strong",
                    "children": [
                      {
                        "text": "「減価償却費」",
                      },
                    ],
                  },
                  {
                    "text": "を決める基準でもあり、節税効果に関係する。",
                  },
                ],
              },
            ],
          },
        ],
      },
      {
        "tag": "p",
        "children": [
          {
            "text": "構造と耐用年数を学んだところで、次はいよいよ「融資（ローン）」そのものの仕組みについて、基礎から学びましょう。",
          },
        ],
      },
      {
        "tag": "hr",
        "children": [],
      },
      {
        "tag": "p",
        "children": [
          {
            "text": "次のコース：",
          },
        ],
      },
      {
        "tag": "a",
        "children": [
          {
            "text": "融資（ローン）の基本：「レバレッジ」とは何か？",
          },
        ],
        "href": "https://propally.co.jp/journal/articles/lp/beginner-7/",
      },
    ],
  },
  "beginner-7": {
    "sourceUrl": "https://propally.co.jp/journal/lp/beginner-7/",
    "sourceTitle": "融資（ローン）の基本：「レバレッジ」とは何か？",
    "acquiredAt": "2026-10-05T07:21:41.048Z",
    "sourceTextSha256": "5879c696876d49187815bd9a0671a5f816d23a7afd08853b967fef67d95bb0c3",
    "nodes": [
      {
        "tag": "p",
        "children": [
          {
            "text": "不動産投資と他の投資（株式や投資信託）との最大の違いは、",
          },
          {
            "text": "「",
          },
          {
            "tag": "strong",
            "children": [
              {
                "text": "融資（ローン）",
              },
            ],
          },
          {
            "text": "」",
          },
          {
            "text": "が利用できる点です。",
          },
        ],
      },
      {
        "tag": "p",
        "children": [
          {
            "text": "「借金＝怖いもの」と考える方も多いかもしれませんが、不動産投資ではこの融資を",
          },
          {
            "text": "「",
          },
          {
            "tag": "strong",
            "children": [
              {
                "text": "レバレッジ",
              },
            ],
          },
          {
            "text": "（テコの原理）」",
          },
          {
            "text": "として活用し、資産形成を加速させます。",
          },
        ],
      },
      {
        "tag": "aside",
        "role": "learn",
        "children": [
          {
            "tag": "strong",
            "children": [
              {
                "text": "学習目標",
              },
            ],
          },
          {
            "tag": "ul",
            "children": [
              {
                "tag": "li",
                "children": [
                  {
                    "text": "なぜ「借金」をしてまで不動産投資を行うのか、その理由（レバレッジ効果）を理解する。",
                  },
                ],
              },
              {
                "tag": "li",
                "children": [
                  {
                    "text": "不動産投資ローンに付帯する「団体信用生命保険（団信）」の役割を知る。",
                  },
                ],
              },
            ],
          },
        ],
      },
      {
        "tag": "h3",
        "children": [
          {
            "tag": "strong",
            "children": [
              {
                "text": "1. なぜ融資を使うのか？ レバレッジ効果",
              },
            ],
          },
        ],
      },
      {
        "tag": "p",
        "children": [
          {
            "text": "レバレッジとは、小さな自己資金（手元の現金）を「テコ」にして、大きな金額のローンを組み、自己資金だけでは買えない高額な資産（不動産）を運用することです。",
          },
        ],
      },
      {
        "tag": "p",
        "children": [
          {
            "tag": "strong",
            "children": [
              {
                "text": "＜例＞ 自己資金300万円で、利回り5%の物件に投資する場合",
              },
            ],
          },
        ],
      },
      {
        "tag": "p",
        "children": [
          {
            "tag": "strong",
            "children": [
              {
                "text": "A. 融資を使わない場合",
              },
            ],
          },
          {
            "tag": "br",
            "children": [],
          },
          {
            "text": "300万円の物件（区分ワンルームなど）を購入。 ",
          },
          {
            "tag": "br",
            "children": [],
          },
          {
            "text": "年間の家賃収入（税引前）：300万円 × 5% = ",
          },
          {
            "tag": "strong",
            "children": [
              {
                "text": "15万円",
              },
            ],
          },
          {
            "tag": "br",
            "children": [],
          },
          {
            "text": "自己資金300万円に対するリターンは ",
          },
          {
            "tag": "strong",
            "children": [
              {
                "text": "5%",
              },
            ],
          },
          {
            "text": " です。",
          },
        ],
        "role": "formula",
      },
      {
        "tag": "p",
        "children": [
          {
            "tag": "strong",
            "children": [
              {
                "text": "B. 融資（レバレッジ）を使う場合",
              },
            ],
          },
          {
            "tag": "br",
            "children": [],
          },
          {
            "text": "自己資金300万円を「頭金」に、2,700万円の融資を組んで、3,000万円の物件（一棟アパートなど）を購入。 ",
          },
          {
            "tag": "br",
            "children": [],
          },
          {
            "text": "年間の家賃収入（税引前）：3,000万円 × 5% = ",
          },
          {
            "tag": "strong",
            "children": [
              {
                "text": "150万円",
              },
            ],
          },
          {
            "tag": "br",
            "children": [],
          },
          {
            "text": "ここからローンの金利（仮に年2% = 54万円）を支払います。 ",
          },
          {
            "tag": "br",
            "children": [],
          },
          {
            "text": "手元に残る利益（税引前）：150万円 – 54万円 = ",
          },
          {
            "tag": "strong",
            "children": [
              {
                "text": "96万円",
              },
            ],
          },
          {
            "tag": "br",
            "children": [],
          },
          {
            "text": "自己資金300万円に対するリターンは ",
          },
          {
            "tag": "strong",
            "children": [
              {
                "text": "32%",
              },
            ],
          },
          {
            "text": " になります。",
          },
        ],
        "role": "formula",
      },
      {
        "tag": "p",
        "children": [
          {
            "text": "このように、融資を利用することで、自己資金に対する収益率（ROI）を劇的に高めることが可能です。",
          },
        ],
      },
      {
        "tag": "h3",
        "children": [
          {
            "tag": "strong",
            "children": [
              {
                "tag": "strong",
                "children": [
                  {
                    "tag": "strong",
                    "children": [
                      {
                        "text": "2. 融資の「リスク」",
                      },
                    ],
                  },
                ],
              },
            ],
          },
        ],
      },
      {
        "tag": "p",
        "children": [
          {
            "text": "もちろん、レバレッジはリターンを高める一方でリスクも伴います。",
          },
        ],
      },
      {
        "tag": "ul",
        "children": [
          {
            "tag": "li",
            "children": [
              {
                "text": "空室が出て家賃収入が減っても、ローンの返済は待ってくれません。",
              },
            ],
          },
          {
            "tag": "li",
            "children": [
              {
                "text": "（変動金利の場合）金利が上昇すると、返済額が増えて収支が悪化します。",
              },
            ],
          },
        ],
      },
      {
        "tag": "h3",
        "children": [
          {
            "tag": "strong",
            "children": [
              {
                "tag": "strong",
                "children": [
                  {
                    "tag": "strong",
                    "children": [
                      {
                        "tag": "strong",
                        "children": [
                          {
                            "tag": "strong",
                            "children": [
                              {
                                "tag": "strong",
                                "children": [
                                  {
                                    "text": "3. 融資のもう一つのメリット",
                                  },
                                ],
                              },
                            ],
                          },
                        ],
                      },
                    ],
                  },
                ],
              },
            ],
          },
        ],
      },
      {
        "tag": "p",
        "children": [
          {
            "text": "不動産投資ローンを組む際、通常「",
          },
          {
            "tag": "strong",
            "children": [
              {
                "text": "団体信用生命保険（団信）",
              },
            ],
          },
          {
            "text": "」への加入が義務付けられます。 これは、ローンの返済中にオーナー（投資家）が死亡、または高度障害状態になった場合、",
          },
          {
            "tag": "strong",
            "children": [
              {
                "text": "残りのローン全額が保険金で完済される",
              },
            ],
          },
          {
            "text": "仕組みです。",
          },
        ],
      },
      {
        "tag": "ul",
        "children": [
          {
            "tag": "li",
            "children": [
              {
                "tag": "strong",
                "children": [
                  {
                    "text": "効果:",
                  },
                ],
              },
              {
                "text": " 遺された家族には、「借金のない不動産（家賃を生み出す資産）」が残ります。",
              },
            ],
          },
          {
            "tag": "li",
            "children": [
              {
                "tag": "strong",
                "children": [
                  {
                    "text": "特徴:",
                  },
                ],
              },
              {
                "text": " このため、不動産投資は「生命保険の代わり」になるとも言われています。",
              },
            ],
          },
        ],
      },
      {
        "tag": "aside",
        "role": "product",
        "children": [
          {
            "tag": "strong",
            "children": [
              {
                "text": "プロパリー活用ポイント",
              },
            ],
          },
          {
            "tag": "p",
            "children": [
              {
                "text": "プロパリーのシミュレーションでは、自己資金、借入額、金利、返済期間を細かく設定し、レバレッジが収支に与える影響を正確に把握できます。",
              },
            ],
          },
        ],
      },
      {
        "tag": "hr",
        "children": [],
      },
      {
        "tag": "aside",
        "role": "summary",
        "children": [
          {
            "tag": "strong",
            "children": [
              {
                "text": "学習ポイントまとめ",
              },
            ],
          },
          {
            "tag": "ul",
            "children": [
              {
                "tag": "li",
                "children": [
                  {
                    "tag": "strong",
                    "children": [
                      {
                        "text": "融資（レバレッジ）",
                      },
                    ],
                  },
                  {
                    "text": "とは、自己資金に対する収益率（ROI）を高めるための強力な手段である。",
                  },
                ],
              },
              {
                "tag": "li",
                "children": [
                  {
                    "text": "レバレッジは収益だけでなく",
                  },
                  {
                    "tag": "strong",
                    "children": [
                      {
                        "text": "リスクも高める",
                      },
                    ],
                  },
                  {
                    "text": "ため、詳細なシミュレーションが不可欠。",
                  },
                ],
              },
              {
                "tag": "li",
                "children": [
                  {
                    "text": "融資に付帯する",
                  },
                  {
                    "tag": "strong",
                    "children": [
                      {
                        "text": "「団信（だんしん）」",
                      },
                    ],
                  },
                  {
                    "text": "には、万が一の際に家族に資産を残せる「生命保険」としての役割もある。",
                  },
                ],
              },
            ],
          },
        ],
      },
      {
        "tag": "p",
        "children": [
          {
            "text": "これで初級編の主要な学習は完了です。最後に、これまでに登場した重要な「専門用語」をおさらいする用語集で知識を定着させましょう。",
          },
        ],
      },
      {
        "tag": "hr",
        "children": [],
      },
    ],
  },
  "beginner-8": {
    "sourceUrl": "https://propally.co.jp/journal/lp/beginner-8/",
    "sourceTitle": "初級編 用語集：押さえておきたい頻出単語",
    "acquiredAt": "2026-10-05T07:21:41.041Z",
    "sourceTextSha256": "eacd977750eef631194a3d6231f510ed1c1031f3f636d73017069cf2fc26c3d2",
    "nodes": [
      {
        "tag": "p",
        "children": [
          {
            "text": "これまでに多くの専門用語が登場しました。最後に、不動産投資の世界で「共通言語」となる、特に重要な単語をおさらいしましょう。",
          },
        ],
      },
      {
        "tag": "aside",
        "role": "learn",
        "children": [
          {
            "tag": "strong",
            "children": [
              {
                "text": "学習目標",
              },
            ],
          },
          {
            "tag": "ul",
            "children": [
              {
                "tag": "li",
                "children": [
                  {
                    "text": "これまでの学習で登場した、特に重要な専門用語の意味を正確に理解し、定着させる。",
                  },
                ],
              },
              {
                "tag": "li",
                "children": [
                  {
                    "text": "中級編以降の学習や、エージェントとの会話で困らないための基礎語彙を身につける。",
                  },
                ],
              },
            ],
          },
        ],
      },
      {
        "tag": "h3",
        "children": [
          {
            "text": "1. キャッシュフロー (CF)",
          },
        ],
      },
      {
        "tag": "p",
        "children": [
          {
            "text": "「手残り」のこと。家賃収入から、ローンの返済、管理費、税金などのすべての支出を差し引いて、最終的に手元に残る現金を指します。",
          },
          {
            "tag": "strong",
            "children": [
              {
                "text": "利益（黒字）なのにキャッシュフローがマイナス（赤字）になる",
              },
            ],
          },
          {
            "text": "こともあるため、常に意識すべき最重要指標です。",
          },
        ],
      },
      {
        "tag": "h3",
        "children": [
          {
            "text": "2. ROI (Return on Investment / 投下資本利益率)",
          },
        ],
      },
      {
        "tag": "p",
        "children": [
          {
            "text": "「自己資金（投下資本）に対して、どれだけのリターン（利益）を生んだか」を示す指標。",
          },
        ],
      },
      {
        "tag": "p",
        "children": [
          {
            "tag": "strong",
            "children": [
              {
                "text": "計算式（簡易）:",
              },
            ],
          },
          {
            "text": " 年間キャッシュフロー ÷ 自己資金 × 100",
          },
        ],
      },
      {
        "tag": "p",
        "children": [
          {
            "text": "レバレッジを効かせる（融資を使う）ほど、このROIは高くなる傾向があります。",
          },
        ],
      },
      {
        "tag": "h3",
        "children": [
          {
            "text": "3. 元利均等返済（がんりきんとうへんさい）",
          },
        ],
      },
      {
        "tag": "p",
        "children": [
          {
            "text": "ローンの返済方法の一つで、毎月の返済額（元金＋利息）が返済終了まで一定の方式です。返済計画が立てやすい反面、返済初期は利息の割合が大きく、元金の減りが遅い特徴があります。",
          },
        ],
      },
      {
        "tag": "h3",
        "children": [
          {
            "text": "4. 元金均等返済（がんきんきんとうへんさい）",
          },
        ],
      },
      {
        "tag": "p",
        "children": [
          {
            "text": "ローンの返済方法の一つで、毎月の返済額のうち「元金」の部分が一定の方式です。利息はローン残高に応じて減っていくため、毎月の総返済額は最初が最も多く、徐々に減っていきます。元利均等返済に比べ、元金の減りが早いのが特徴です。",
          },
        ],
      },
      {
        "tag": "h3",
        "children": [
          {
            "text": "5. 減価償却（げんかしょうきゃく）",
          },
        ],
      },
      {
        "tag": "p",
        "children": [
          {
            "text": "建物の購入費用を、法定耐用年数（木造22年、RC造47年など）にわたって分割し、毎年「経費」として計上すること。実際にお金は出ていきませんが（非現金支出費用）、税務上の利益を圧縮できるため、節税効果を生み出します。",
          },
        ],
      },
      {
        "tag": "h3",
        "children": [
          {
            "text": "6. 積算評価（せきさんひょうか）",
          },
        ],
      },
      {
        "tag": "p",
        "children": [
          {
            "text": "金融機関が物件を評価する方法の一つ。「土地の価値」と「建物の価値（再調達価格×延床面積）」を足して算出します。特に地方の物件や、一棟ものの融資審査で重視される傾向があります。",
          },
        ],
      },
      {
        "tag": "h3",
        "children": [
          {
            "text": "7. 収益還元評価（しゅうえきかんげんひょうか）",
          },
        ],
      },
      {
        "tag": "p",
        "children": [
          {
            "text": "金融機関が物件を評価する方法の一つ。「その物件が将来どれだけの収益（家賃）を生み出すか」を基準に価値を算出します。主に都心部の物件や、区分マンションの融資審査で重視される傾向があります。",
          },
        ],
      },
      {
        "tag": "h3",
        "children": [
          {
            "text": "8. サブリース（家賃保証）",
          },
        ],
      },
      {
        "tag": "p",
        "children": [
          {
            "text": "不動産会社がオーナーから物件を借り上げ、入居者に転貸（又貸し）する仕組み。「空室時でも一定の家賃が保証される」というメリットがありますが、通常の管理委託より手数料が高く、数年ごとに家賃（保証額）が見直されて減額されるリスクもあります。",
          },
        ],
      },
      {
        "tag": "h3",
        "children": [
          {
            "text": "9. 団体信用生命保険（だんしん）",
          },
        ],
      },
      {
        "tag": "p",
        "children": [
          {
            "text": "住宅ローンや投資ローンを組む際に加入する生命保険。ローンの返済中にオーナーが死亡・高度障害になった場合、残りのローンが全額完済されます。遺族に「借金のない資産」を残せるため、生命保険の代わりとも言われます。",
          },
        ],
      },
      {
        "tag": "hr",
        "children": [],
      },
      {
        "tag": "aside",
        "role": "summary",
        "children": [
          {
            "tag": "strong",
            "children": [
              {
                "text": "学習ポイントまとめ",
              },
            ],
          },
          {
            "tag": "ul",
            "children": [
              {
                "tag": "li",
                "children": [
                  {
                    "text": "これらの用語は、エージェントとの会話やシミュレーション、確定申告の際に必ず登場する。",
                  },
                ],
              },
              {
                "tag": "li",
                "children": [
                  {
                    "text": "言葉の意味を正確に理解することが、投資判断のミスを防ぐ第一歩となる。",
                  },
                ],
              },
            ],
          },
        ],
      },
      {
        "tag": "p",
        "children": [
          {
            "text": "お疲れさまでした！ これで不動産投資の「基礎」はすべて完了です。 次は中級編を学びましょう。",
          },
        ],
      },
      {
        "tag": "hr",
        "children": [],
      },
    ],
  },
  "intermediate-1": {
    "sourceUrl": "https://propally.co.jp/journal/lp/intermediate-1/",
    "sourceTitle": "「買うべきエリア」の選定方法：データ分析の基礎",
    "acquiredAt": "2026-10-05T07:21:40.999Z",
    "sourceTextSha256": "4214828194fbcc38c7e790f9853408af450be881ba3551297c91429e02d631bc",
    "nodes": [
      {
        "tag": "p",
        "children": [
          {
            "text": "不動産投資は「立地がすべて」と言われるほど、エリア選定が成否を分けます。初級編では「駅近」などの基礎を学びましたが、中級編では「なぜその駅（エリア）が強いのか」を",
          },
          {
            "tag": "strong",
            "children": [
              {
                "text": "データで裏付ける",
              },
            ],
          },
          {
            "text": "技術を学びます。",
          },
        ],
      },
      {
        "tag": "p",
        "children": [
          {
            "text": "感覚や、不動産エージェントの「ここはオススメですよ」という言葉だけを鵜呑みにせず、自ら分析する「目」を持ちましょう。",
          },
        ],
      },
      {
        "tag": "aside",
        "role": "learn",
        "children": [
          {
            "tag": "strong",
            "children": [
              {
                "text": "学習目標",
              },
            ],
          },
          {
            "tag": "ul",
            "children": [
              {
                "tag": "li",
                "children": [
                  {
                    "text": "「なんとなく良さそう」という感覚的な選定から脱却し、データに基づいたエリア選定ができるようになる。",
                  },
                ],
              },
              {
                "tag": "li",
                "children": [
                  {
                    "text": "人口動態、賃貸需要、競合状況など、エリア分析で「見るべき数字」を理解する。",
                  },
                ],
              },
            ],
          },
        ],
      },
      {
        "tag": "h3",
        "children": [
          {
            "text": "1. 人口動態：『人は集まっているか？』",
          },
        ],
      },
      {
        "tag": "p",
        "children": [
          {
            "tag": "strong",
            "children": [
              {
                "text": "見るべき指標:",
              },
            ],
          },
          {
            "text": " 「",
          },
          {
            "tag": "strong",
            "children": [
              {
                "text": "社会増減",
              },
            ],
          },
          {
            "text": "（転入者数 － 転出者数）」",
          },
        ],
      },
      {
        "tag": "p",
        "children": [
          {
            "tag": "strong",
            "children": [
              {
                "text": "分析:",
              },
            ],
          },
          {
            "text": " 総人口が減っていても、「社会増（＝引越してくる人が多い）」エリアは賃貸需要が強いと判断できます。逆に、総人口が増えていても「自然増（出生数が多い）」だけの場合、賃貸需要とは直結しないため注意が必要です。",
          },
        ],
      },
      {
        "tag": "p",
        "children": [
          {
            "tag": "strong",
            "children": [
              {
                "text": "情報源:",
              },
            ],
          },
          {
            "text": " 各自治体（市区町村）のウェブサイト、総務省統計局の「住民基本台帳人口移動報告」",
          },
        ],
      },
      {
        "tag": "h3",
        "children": [
          {
            "tag": "strong",
            "children": [
              {
                "text": "2. 賃貸需要（ターゲット）：『誰が住むのか？』",
              },
            ],
          },
        ],
      },
      {
        "tag": "p",
        "children": [
          {
            "tag": "strong",
            "children": [
              {
                "text": "見るべき指標:",
              },
            ],
          },
          {
            "text": " エリアの「",
          },
          {
            "tag": "strong",
            "children": [
              {
                "text": "世帯構成",
              },
            ],
          },
          {
            "text": "（単身者、ファミリーなど）」",
          },
        ],
      },
      {
        "tag": "p",
        "children": [
          {
            "tag": "strong",
            "children": [
              {
                "text": "分析:",
              },
            ],
          },
          {
            "text": " 大学や大企業のキャンパス・本社が近くにあれば「単身者（ワンルーム）」の需要が強いと推測できます。一方、小中学校や公園が多いエリアは「ファミリー（2LDK以上）」の需要が強いでしょう。 あなたが検討している物件（例：ワンルーム）と、そのエリアの主な賃貸需要（例：ファミリー層）がミスマッチしていると、空室リスクが高まります。",
          },
        ],
      },
      {
        "tag": "h3",
        "children": [
          {
            "tag": "strong",
            "children": [
              {
                "tag": "strong",
                "children": [
                  {
                    "text": "3. 競合状況：『ライバルは多いか？』",
                  },
                ],
              },
            ],
          },
        ],
      },
      {
        "tag": "p",
        "children": [
          {
            "tag": "strong",
            "children": [
              {
                "text": "見るべき指標:",
              },
            ],
          },
          {
            "text": " 「",
          },
          {
            "tag": "strong",
            "children": [
              {
                "text": "新築物件の供給量",
              },
            ],
          },
          {
            "text": "」「",
          },
          {
            "tag": "strong",
            "children": [
              {
                "text": "賃貸物件の空室率",
              },
            ],
          },
          {
            "text": "」",
          },
        ],
      },
      {
        "tag": "p",
        "children": [
          {
            "tag": "strong",
            "children": [
              {
                "text": "分析:",
              },
            ],
          },
          {
            "text": " いくら需要が多くても、それを上回るペースで新築（ライバル）が供給され続けているエリアは、将来的に家賃の下落競争（価格競争）に巻き込まれるリスクがあります。 「需要（借りたい人）」と「供給（貸せる部屋）」のバランスを見極めることが重要です。",
          },
        ],
      },
      {
        "tag": "aside",
        "role": "summary",
        "children": [
          {
            "tag": "strong",
            "children": [
              {
                "text": "学習ポイントまとめ",
              },
            ],
          },
          {
            "tag": "p",
            "children": [
              {
                "text": "エリア選定は「感覚」ではなく「データ」で行う。",
              },
            ],
          },
          {
            "tag": "p",
            "children": [
              {
                "tag": "strong",
                "children": [
                  {
                    "text": "「人口（社会増減）」",
                  },
                ],
              },
              {
                "tag": "br",
                "children": [],
              },
              {
                "tag": "strong",
                "children": [
                  {
                    "text": "「ターゲット（世帯構成）」",
                  },
                ],
              },
              {
                "tag": "br",
                "children": [],
              },
              {
                "tag": "strong",
                "children": [
                  {
                    "text": "「競合（供給量）」",
                  },
                ],
              },
            ],
          },
          {
            "tag": "p",
            "children": [
              {
                "text": "3つのバランスを見ることで、将来の空室リスクや家賃下落リスクを予測する。",
              },
            ],
          },
        ],
      },
      {
        "tag": "p",
        "children": [
          {
            "text": " データで「買うべきエリア」を絞り込めたら、次はいよいよ現地に赴き、「買ってはいけない物件」を見抜くための具体的なチェックリストを学びましょう。",
          },
        ],
      },
      {
        "tag": "hr",
        "children": [],
      },
    ],
  },
  "intermediate-2": {
    "sourceUrl": "https://propally.co.jp/journal/lp/intermediate-2/",
    "sourceTitle": "「買ってはいけない物件」の見抜き方：現地調査（内見）の全チェックリスト",
    "acquiredAt": "2026-10-05T07:21:41.161Z",
    "sourceTextSha256": "8c6180ff3e53734776e4b03e152aec1b11e7cdbc9e4d8cb2a4008ba7bdc0c6ab",
    "nodes": [
      {
        "tag": "p",
        "children": [
          {
            "text": "エリア選定（データ分析）をクリアしても、すべての物件が良いわけではありません。データ上はAクラスでも、現地を見るとCクラス、という物件は山ほどあります。",
          },
        ],
      },
      {
        "tag": "p",
        "children": [
          {
            "text": "不動産エージェントが同行する「室内（専有部）」の内見だけでは不十分です。投資家として、本当に確認すべきは",
          },
          {
            "tag": "strong",
            "children": [
              {
                "text": "「建物の管理状態」と「入居者の質」",
              },
            ],
          },
          {
            "text": "です。",
          },
        ],
      },
      {
        "tag": "p",
        "children": [
          {
            "text": "「買ってはいけない物件」を避けるため、以下のチェックリストを必ず確認してください。",
          },
        ],
      },
      {
        "tag": "aside",
        "role": "learn",
        "children": [
          {
            "tag": "strong",
            "children": [
              {
                "text": "学習目標",
              },
            ],
          },
          {
            "tag": "ul",
            "children": [
              {
                "tag": "li",
                "children": [
                  {
                    "text": "物件資料（図面や写真）だけでは分からない「隠れたリスク」を、現地調査（内見）で見抜くスキルを身につける。",
                  },
                ],
              },
              {
                "tag": "li",
                "children": [
                  {
                    "text": "チェックすべきポイントを「共用部」「専有部」「周辺環境」の3つに分けて理解する。",
                  },
                ],
              },
            ],
          },
        ],
      },
      {
        "tag": "h3",
        "children": [
          {
            "tag": "strong",
            "children": [
              {
                "text": "1.【共用部】：管理の質と入居者の「民度」が表れる場所",
              },
            ],
          },
        ],
      },
      {
        "tag": "p",
        "children": [
          {
            "text": "オーナーとして、室内（専有部）はリフォームできても、共用部は変えられません。",
          },
        ],
      },
      {
        "tag": "p",
        "children": [
          {
            "tag": "strong",
            "children": [
              {
                "text": "☐ 外壁・塗装:",
              },
            ],
          },
          {
            "text": " 目立つヒビ割れ（クラック）、塗装の剥がれ、漏水の跡はないか？（→大規模修繕が近い、または必要なのに行われていない可能性）",
          },
        ],
      },
      {
        "tag": "p",
        "children": [
          {
            "tag": "strong",
            "children": [
              {
                "text": "☐ エントランス・郵便受け:",
              },
            ],
          },
          {
            "text": " 清掃は行き届いているか？ 郵便受けがチラシで溢れかえっていたり、壊れたまま放置されていないか？（→長期空室や管理不全のサイン）",
          },
        ],
      },
      {
        "tag": "p",
        "children": [
          {
            "tag": "strong",
            "children": [
              {
                "text": "☐ ゴミ置き場:",
              },
            ],
          },
          {
            "text": " 曜日ルールが守られ、整理整頓されているか？ 悪臭やカラスが荒らした跡はないか？（→管理会社と入居者の質が最も出やすい場所）",
          },
        ],
      },
      {
        "tag": "p",
        "children": [
          {
            "tag": "strong",
            "children": [
              {
                "text": "☐ 駐輪場・駐車場:",
              },
            ],
          },
          {
            "text": " 乱雑に停められていないか？ 放置されたままの（パンクした）自転車はないか？",
          },
        ],
      },
      {
        "tag": "p",
        "children": [
          {
            "tag": "strong",
            "children": [
              {
                "text": "☐ 廊下・階段:",
              },
            ],
          },
          {
            "text": " 電球は切れていないか？ 住民の私物（ベビーカー、タイヤなど）が放置されていないか？",
          },
        ],
      },
      {
        "tag": "p",
        "children": [
          {
            "tag": "strong",
            "children": [
              {
                "text": "☐ 掲示板:",
              },
            ],
          },
          {
            "text": " 管理会社からのお知らせ（清掃、点検）は定期的に更新されているか？ 古い情報が貼りっぱなしになっていないか？",
          },
        ],
      },
      {
        "tag": "h3",
        "children": [
          {
            "tag": "strong",
            "children": [
              {
                "tag": "strong",
                "children": [
                  {
                    "text": "2.【専有部】：入居者の「快適さ」に直結する場所",
                  },
                ],
              },
            ],
          },
        ],
      },
      {
        "tag": "p",
        "children": [
          {
            "tag": "strong",
            "children": [
              {
                "text": "☐ 水圧・排水:",
              },
            ],
          },
          {
            "text": " キッチン、浴室、洗面台、すべての蛇口を全開にし、水圧は十分か確認する。水を流し、排水口から異臭（下水臭）がしないか確認する。",
          },
        ],
      },
      {
        "tag": "p",
        "children": [
          {
            "tag": "strong",
            "children": [
              {
                "text": "☐ 音・振動:",
              },
            ],
          },
          {
            "text": " 窓を閉めた状態、開けた状態で、外の音（車、電車、近隣の商業施設）がどれだけ響くか確認する。（※特に木造・鉄骨造は、隣室や上下階の生活音も要チェック）",
          },
        ],
      },
      {
        "tag": "p",
        "children": [
          {
            "tag": "strong",
            "children": [
              {
                "text": "☐ 日当たり・湿気:",
              },
            ],
          },
          {
            "text": " 日当たり（特にバルコニーの向き）を確認する。クローゼットや押し入れの奥、窓のサッシ周辺に「カビ」の跡がないか注意深く見る。",
          },
        ],
      },
      {
        "tag": "p",
        "children": [
          {
            "tag": "strong",
            "children": [
              {
                "text": "☐ 電波状況:",
              },
            ],
          },
          {
            "text": " 自分のスマートフォンを取り出し、アンテナが何本立つか確認する。（電波が悪い部屋は、それだけで入居者に敬遠されます）",
          },
        ],
      },
      {
        "tag": "h3",
        "children": [
          {
            "tag": "strong",
            "children": [
              {
                "tag": "strong",
                "children": [
                  {
                    "text": "3.【周辺環境】：入居者の「生活」を想像する",
                  },
                ],
              },
            ],
          },
        ],
      },
      {
        "tag": "p",
        "children": [
          {
            "tag": "strong",
            "children": [
              {
                "text": "☐ 駅からの道のり:",
              },
            ],
          },
          {
            "text": " 必ず自分の足で歩く。「徒歩10分」の体感は？ 夜道は暗くないか？ 坂道はきつくないか？",
          },
        ],
      },
      {
        "tag": "p",
        "children": [
          {
            "tag": "strong",
            "children": [
              {
                "text": "☐ 嫌悪施設（けんおしせつ）:",
              },
            ],
          },
          {
            "text": " 物件の隣や向かいに、騒音や悪臭の原因となるもの（例：ゴミ処理場、大型幹線道路、風俗店、パチンコ店、においの強い飲食店）がないか確認する。",
          },
        ],
      },
      {
        "tag": "p",
        "children": [
          {
            "tag": "strong",
            "children": [
              {
                "text": "☐ 生活利便性:",
              },
            ],
          },
          {
            "text": " 入居者ターゲット（単身者、ファミリー）に合ったスーパーやコンビニ、ドラッグストア、公園などが近くにあるか確認する。",
          },
        ],
      },
      {
        "tag": "aside",
        "role": "summary",
        "children": [
          {
            "tag": "strong",
            "children": [
              {
                "text": "学習ポイントまとめ",
              },
            ],
          },
          {
            "tag": "p",
            "children": [
              {
                "text": "現地調査（内見）とは、",
              },
              {
                "tag": "strong",
                "children": [
                  {
                    "text": "図面と現実の「ギャップ」",
                  },
                ],
              },
              {
                "text": "や、資料に載らない",
              },
              {
                "tag": "strong",
                "children": [
                  {
                    "text": "「違和感」",
                  },
                ],
              },
              {
                "text": "を見つけ出す作業である。",
              },
            ],
          },
          {
            "tag": "p",
            "children": [
              {
                "text": "「共用部」を見れば、その物件の「管理の質」と「入居者の質」がほぼ予測できる。",
              },
            ],
          },
          {
            "tag": "p",
            "children": [
              {
                "text": "「室内」がいくら綺麗でも、共用部が荒れている物件は避けるべき。",
              },
            ],
          },
        ],
      },
      {
        "tag": "p",
        "children": [
          {
            "text": "現地で「この物件は良い」と判断できたら、次はその物件の「価格」が果たして妥当なのか、市場価格（相場）を調べる方法を学びましょう。",
          },
        ],
      },
      {
        "tag": "hr",
        "children": [],
      },
    ],
  },
  "intermediate-3": {
    "sourceUrl": "https://propally.co.jp/journal/lp/intermediate-3/",
    "sourceTitle": "物件価格の妥当性を知る（成約事例検索 活用術）",
    "acquiredAt": "2026-10-05T07:21:41.205Z",
    "sourceTextSha256": "4b12607fff8b689914fdc65eb945805d5bd76bddd9a802407d63a506a5662e28",
    "nodes": [
      {
        "tag": "p",
        "children": [
          {
            "text": "現地調査（内見）を終え、いよいよ「購入したい」という気持ちが高まった時、最後に立ちはだかるのが「",
          },
          {
            "tag": "strong",
            "children": [
              {
                "text": "価格交渉",
              },
            ],
          },
          {
            "text": "」と「",
          },
          {
            "tag": "strong",
            "children": [
              {
                "text": "最終判断",
              },
            ],
          },
          {
            "text": "」です。",
          },
        ],
      },
      {
        "tag": "p",
        "children": [
          {
            "text": "営業マンから提示された価格、あるいはポータルサイトに掲載されている価格。それは本当に「適正な価格」でしょうか？",
          },
        ],
      },
      {
        "tag": "aside",
        "role": "learn",
        "children": [
          {
            "tag": "strong",
            "children": [
              {
                "text": "学習目標",
              },
            ],
          },
          {
            "tag": "ul",
            "children": [
              {
                "tag": "li",
                "children": [
                  {
                    "text": "「売り出し価格」と「成約価格」は違うことを理解する。",
                  },
                ],
              },
              {
                "tag": "li",
                "children": [
                  {
                    "text": "客観的なデータ（過去の取引事例）と比較することで、提示された価格が妥当か（割高でないか）を判断するスキルを身につける。",
                  },
                ],
              },
            ],
          },
        ],
      },
      {
        "tag": "h3",
        "children": [
          {
            "text": "1. ",
          },
          {
            "tag": "strong",
            "children": [
              {
                "text": "「売り出し価格」≠「成約価格」",
              },
            ],
          },
        ],
      },
      {
        "tag": "p",
        "children": [
          {
            "text": "まず大原則として、広告に載っている「",
          },
          {
            "tag": "strong",
            "children": [
              {
                "text": "売り出し価格",
              },
            ],
          },
          {
            "text": "」は、あくまで「",
          },
          {
            "tag": "strong",
            "children": [
              {
                "text": "売り手が希望する価格",
              },
            ],
          },
          {
            "text": "」にすぎません。 投資家として本当に知りたいのは、「",
          },
          {
            "tag": "strong",
            "children": [
              {
                "text": "その物件が、そのエリアで、過去にいくらで取引されたか",
              },
            ],
          },
          {
            "text": "」という「",
          },
          {
            "tag": "strong",
            "children": [
              {
                "text": "成約価格",
              },
            ],
          },
          {
            "text": "」のデータです。",
          },
        ],
      },
      {
        "tag": "p",
        "children": [
          {
            "text": "この成約価格（相場）を知らなければ、あなたが「割高な価格」で物件を掴んでしまうリスクがあります。",
          },
        ],
      },
      {
        "tag": "h3",
        "children": [
          {
            "text": "2. ",
          },
          {
            "tag": "strong",
            "children": [
              {
                "tag": "strong",
                "children": [
                  {
                    "text": "価格の妥当性をどう調べるか？",
                  },
                ],
              },
            ],
          },
        ],
      },
      {
        "tag": "p",
        "children": [
          {
            "text": "従来、この「成約価格」データは、不動産会社しかアクセスできないデータベース（REINS）などに限定されており、個人の投資家が知ることは困難でした。",
          },
        ],
      },
      {
        "tag": "p",
        "children": [
          {
            "text": "しかし、今はテクノロジーを活用することで、その一部を把握することが可能です。",
          },
        ],
      },
      {
        "tag": "aside",
        "role": "product",
        "children": [
          {
            "tag": "strong",
            "children": [
              {
                "text": "プロパリー活用ポイント",
              },
            ],
          },
          {
            "tag": "p",
            "children": [
              {
                "text": "プロパリーでは、この",
              },
              {
                "tag": "strong",
                "children": [
                  {
                    "text": "「過去の成約事例（価格）」",
                  },
                ],
              },
              {
                "text": "を検索できる機能を提供しています 。",
              },
            ],
          },
          {
            "tag": "p",
            "children": [
              {
                "text": "あなたが検討している物件や、保有している物件と同じエリアの過去の取引事例を調べることで、その「",
              },
              {
                "tag": "strong",
                "children": [
                  {
                    "text": "適正価格",
                  },
                ],
              },
              {
                "text": "」を把握するための客観的な参考情報となります 。",
              },
            ],
          },
          {
            "tag": "p",
            "children": [
              {
                "text": "例えば、検討中の物件が3,000万円で売りに出されていても、似た条件の成約事例が2,500万円前後で集中していれば、「この価格は割高かもしれない」と判断し、価格交渉の材料にすることができます。",
              },
            ],
          },
          {
            "tag": "p",
            "children": [
              {
                "text": "※データが古い場合は、物件価格が大きくズレている可能性があります。",
              },
            ],
          },
        ],
      },
      {
        "tag": "hr",
        "children": [],
      },
      {
        "tag": "aside",
        "role": "summary",
        "children": [
          {
            "tag": "strong",
            "children": [
              {
                "text": "学習ポイントまとめ",
              },
            ],
          },
          {
            "tag": "p",
            "children": [
              {
                "text": "広告の",
              },
              {
                "tag": "strong",
                "children": [
                  {
                    "text": "「売り出し価格」",
                  },
                ],
              },
              {
                "text": "を鵜呑みにしてはいけない。",
              },
            ],
          },
          {
            "tag": "p",
            "children": [
              {
                "text": "投資判断は、必ず",
              },
              {
                "tag": "strong",
                "children": [
                  {
                    "text": "「成約価格」",
                  },
                ],
              },
              {
                "text": "という客観的なデータ（相場）に基づいて行う。",
              },
            ],
          },
          {
            "tag": "p",
            "children": [
              {
                "text": "プロパリーの「成約事例検索」は、その相場を把握し、割高な買い物を避けるための強力なツールとなる 。",
              },
            ],
          },
        ],
      },
      {
        "tag": "p",
        "children": [
          {
            "text": " 物件の「価格」が妥当だと判断できたら、次はいよいよ購入プロセスで最大の関門となる「融資（ローン）」について、銀行が個人をどう評価するのか、その戦略を学びましょう。",
          },
        ],
      },
      {
        "tag": "hr",
        "children": [],
      },
    ],
  },
  "intermediate-4": {
    "sourceUrl": "https://propally.co.jp/journal/lp/intermediate-4/",
    "sourceTitle": "融資戦略（中級）：銀行は個人の「属性」をどう評価するか？",
    "acquiredAt": "2026-10-05T07:21:41.205Z",
    "sourceTextSha256": "b3dc3f6e50466030957addbb83d97eaa5dcb9d8adcd3ec0643157201e9ae5c5e",
    "nodes": [
      {
        "tag": "p",
        "children": [
          {
            "text": "不動産投資は「融資に始まり、融資に終わる」と言われるほど、金融機関との付き合い方が重要です。 初級編では「レバレッジ」の基礎を学びましたが、中級編では「どうすれば、より良い条件（低金利・長期間）で融資を受けられるか」を学びます。",
          },
        ],
      },
      {
        "tag": "p",
        "children": [
          {
            "text": "銀行は、",
          },
          {
            "tag": "strong",
            "children": [
              {
                "text": "個人の「属性」",
              },
            ],
          },
          {
            "text": "（＝返済能力と信用力）と、**「物件の収益性/担保価値」**の両方を見て融資を判断します。ここでは「属性」に焦点を当てます。",
          },
        ],
      },
      {
        "tag": "p",
        "children": [
          {
            "text": "銀行が特に重視する「属性」の項目は以下の通りです。",
          },
        ],
      },
      {
        "tag": "aside",
        "role": "learn",
        "children": [
          {
            "tag": "strong",
            "children": [
              {
                "text": "学習目標",
              },
            ],
          },
          {
            "tag": "ul",
            "children": [
              {
                "tag": "li",
                "children": [
                  {
                    "text": "金融機関（銀行）が融資審査の際に個人の何を見ているか、いわゆる「属性」の評価基準を理解する。",
                  },
                ],
              },
              {
                "tag": "li",
                "children": [
                  {
                    "text": "ご自身の「属性」を踏まえ、どの金融機関にアプローチすべきか、戦略を立てるための基礎知識を身につける。",
                  },
                ],
              },
            ],
          },
        ],
      },
      {
        "tag": "h3",
        "children": [
          {
            "text": "1. ",
          },
          {
            "tag": "strong",
            "children": [
              {
                "text": "勤務先",
              },
            ],
          },
        ],
      },
      {
        "tag": "p",
        "children": [
          {
            "tag": "strong",
            "children": [
              {
                "text": "見られる点:",
              },
            ],
          },
          {
            "text": " 会社の規模、業種、安定性、上場/非上場など。",
          },
        ],
      },
      {
        "tag": "p",
        "children": [
          {
            "tag": "strong",
            "children": [
              {
                "text": "評価:",
              },
            ],
          },
          {
            "text": " 倒産リスクが低く、給与が安定していると見なされる「上場企業」「公務員」「医師・弁護士などの士業」は、最も高く評価されます。",
          },
        ],
      },
      {
        "tag": "h3",
        "children": [
          {
            "tag": "strong",
            "children": [
              {
                "text": "2. 勤続年数",
              },
            ],
          },
        ],
      },
      {
        "tag": "p",
        "children": [
          {
            "tag": "strong",
            "children": [
              {
                "text": "見られる点:",
              },
            ],
          },
          {
            "text": " 現在の勤務先に何年勤めているか。",
          },
        ],
      },
      {
        "tag": "p",
        "children": [
          {
            "tag": "strong",
            "children": [
              {
                "text": "評価:",
              },
            ],
          },
          {
            "text": " 「最低3年以上」を融資の目安としている銀行が多いです。勤続年数が短い（例：1年未満）と、収入が一時的なものでないか判断できず、審査が厳しくなります。",
          },
        ],
      },
      {
        "tag": "h3",
        "children": [
          {
            "tag": "strong",
            "children": [
              {
                "text": "3. 年収",
              },
            ],
          },
        ],
      },
      {
        "tag": "p",
        "children": [
          {
            "tag": "strong",
            "children": [
              {
                "text": "見られる点:",
              },
            ],
          },
          {
            "text": " 安定した給与収入がいくらあるか。（事業所得や一時的な所得は別で見られます）",
          },
        ],
      },
      {
        "tag": "p",
        "children": [
          {
            "tag": "strong",
            "children": [
              {
                "text": "評価:",
              },
            ],
          },
          {
            "text": " 金融機関や物件種別によりますが、アパートローンなどでは「年収700万円以上」や「年収1,000万円以上」といった基準を設けている場合があります。",
          },
        ],
      },
      {
        "tag": "h3",
        "children": [
          {
            "tag": "strong",
            "children": [
              {
                "text": "4. 自己資金（金融資産）",
              },
            ],
          },
        ],
      },
      {
        "tag": "p",
        "children": [
          {
            "tag": "strong",
            "children": [
              {
                "text": "見られる点:",
              },
            ],
          },
          {
            "text": " 物件購入に充てる頭金と、それ以外にどれだけの現金・預金・有価証券を持っているか。",
          },
        ],
      },
      {
        "tag": "p",
        "children": [
          {
            "tag": "strong",
            "children": [
              {
                "text": "評価:",
              },
            ],
          },
          {
            "text": " 自己資金（頭金）を物件価格の1〜2割程度入れることで、銀行側のリスクが減り、融資が格段に通りやすくなります。また、十分な金融資産があることは「万が一、空室になっても返済できる余力がある」という強い証明になります。",
          },
        ],
      },
      {
        "tag": "h3",
        "children": [
          {
            "tag": "strong",
            "children": [
              {
                "text": "5. 既存借入の状況",
              },
            ],
          },
        ],
      },
      {
        "tag": "p",
        "children": [
          {
            "tag": "strong",
            "children": [
              {
                "text": "見られる点:",
              },
            ],
          },
          {
            "text": " 他のローンの残高（住宅ローン、自動車ローン、カードローンなど）。",
          },
        ],
      },
      {
        "tag": "p",
        "children": [
          {
            "tag": "strong",
            "children": [
              {
                "text": "評価:",
              },
            ],
          },
          {
            "text": " 最も厳しく見られる項目の一つです。特にカードローンやリボ払いの残債があると、個人の資金管理能力を疑われ、それだけで審査に落ちる原因にもなります。",
          },
        ],
      },
      {
        "tag": "p",
        "children": [
          {
            "tag": "strong",
            "children": [
              {
                "text": "指標:",
              },
            ],
          },
          {
            "text": " 銀行は「",
          },
          {
            "tag": "strong",
            "children": [
              {
                "text": "DSR（総負債返済比率）",
              },
            ],
          },
          {
            "text": "」＝（年間のすべてのローン返済額 ÷ 年収）を見ており、この比率が高すぎると（例：35%超）、新規の融資は難しくなります。",
          },
        ],
      },
      {
        "tag": "aside",
        "role": "summary",
        "children": [
          {
            "tag": "strong",
            "children": [
              {
                "text": "学習ポイントまとめ",
              },
            ],
          },
          {
            "tag": "p",
            "children": [
              {
                "text": "銀行は「この人にお金を貸して、最後まで返してくれるか？」を判断するために、個人の",
              },
              {
                "tag": "strong",
                "children": [
                  {
                    "text": "「属性」（勤務先、年収、資産、既存借入）を総合的に評価する",
                  },
                ],
              },
              {
                "text": "。",
              },
            ],
          },
          {
            "tag": "p",
            "children": [
              {
                "tag": "strong",
                "children": [
                  {
                    "text": "「属性」",
                  },
                ],
              },
              {
                "text": "が強ければ、より低金利・長期間という",
              },
              {
                "tag": "strong",
                "children": [
                  {
                    "text": "「良い条件」",
                  },
                ],
              },
              {
                "text": "で融資を受けられる可能性が高まる。",
              },
            ],
          },
          {
            "tag": "p",
            "children": [
              {
                "text": "自分の属性を客観的に把握し、不要な借入（カードローンなど）は整理しておくことが融資戦略の第一歩となる。",
              },
            ],
          },
        ],
      },
      {
        "tag": "h2",
        "children": [
          {
            "tag": "strong",
            "children": [
              {
                "text": "【次のアクション（CTA）】 ",
              },
            ],
          },
        ],
      },
      {
        "tag": "p",
        "children": [
          {
            "text": "無事に融資が組めたとして、次はその後の「キャッシュフロー（手残り）」を最大化するために不可欠な、「税務」の知識（減価償却）について学びましょう。",
          },
        ],
      },
      {
        "tag": "hr",
        "children": [],
      },
    ],
  },
  "intermediate-5": {
    "sourceUrl": "https://propally.co.jp/journal/lp/intermediate-5/",
    "sourceTitle": "キャッシュフローを最大化する「税務」の知識",
    "acquiredAt": "2026-10-05T07:21:41.314Z",
    "sourceTextSha256": "c9e7dc039b9c01c44023f67d7c3ebd0c34d667b5a2b770a3f1ca04db4e618bf9",
    "nodes": [
      {
        "tag": "p",
        "children": [
          {
            "text": "不動産投資の収支を考えるとき、「税務上の利益」と「手元に残る現金（キャッシュフロー）」は必ずしも一致しません。このズレを理解することが、キャッシュフローを最大化する鍵となります。",
          },
        ],
      },
      {
        "tag": "aside",
        "role": "learn",
        "children": [
          {
            "tag": "strong",
            "children": [
              {
                "text": "学習目標",
              },
            ],
          },
          {
            "tag": "ul",
            "children": [
              {
                "tag": "li",
                "children": [
                  {
                    "text": "「減価償却」が節税（キャッシュフローの改善）につながる仕組みを理解する。",
                  },
                ],
              },
            ],
          },
        ],
      },
      {
        "tag": "h3",
        "children": [
          {
            "tag": "strong",
            "children": [
              {
                "text": "「減価償却」：お金が出ていかない経費",
              },
            ],
          },
        ],
      },
      {
        "tag": "p",
        "children": [
          {
            "text": "初級編でも触れましたが、「減価償却」とは、建物の購入費用を法定耐用年数（例：RC造なら47年）にわたって分割し、毎年「経費」として計上する税務上のルールです。",
          },
        ],
      },
      {
        "tag": "p",
        "children": [
          {
            "text": "減価償却費は、",
          },
          {
            "tag": "strong",
            "children": [
              {
                "text": "実際にはお金が出ていかない（支出を伴わない）経費",
              },
            ],
          },
          {
            "text": "です。",
          },
        ],
      },
      {
        "tag": "p",
        "children": [
          {
            "text": "経費が（帳簿上）増えるため、そのぶん「税務上の利益」が圧縮されます。その結果、支払う所得税や住民税が少なくなり、",
          },
          {
            "tag": "strong",
            "children": [
              {
                "text": "手元に残る現金（キャッシュフロー）が増える",
              },
            ],
          },
          {
            "text": "ことになります。これは不動産投資における大きなメリット（節税効果）の一つです。",
          },
        ],
      },
      {
        "tag": "aside",
        "role": "summary",
        "children": [
          {
            "tag": "strong",
            "children": [
              {
                "text": "学習ポイントまとめ",
              },
            ],
          },
          {
            "tag": "p",
            "children": [
              {
                "tag": "strong",
                "children": [
                  {
                    "text": "「減価償却」",
                  },
                ],
              },
              {
                "text": "は、税金を減らしてキャッシュフローを増やす",
              },
              {
                "tag": "strong",
                "children": [
                  {
                    "text": "「味方」",
                  },
                ],
              },
              {
                "text": "である。",
              },
            ],
          },
        ],
      },
      {
        "tag": "p",
        "children": [
          {
            "text": "税務の知識を学んだら、次は物件購入後の「運営」の成功を左右する、重要なパートナー「賃貸管理会社」の選び方について学びましょう。",
          },
        ],
      },
      {
        "tag": "hr",
        "children": [],
      },
    ],
  },
  "intermediate-6": {
    "sourceUrl": "https://propally.co.jp/journal/lp/intermediate-6/",
    "sourceTitle": "成功を左右する「賃貸管理会社」の選び方",
    "acquiredAt": "2026-10-05T07:21:41.361Z",
    "sourceTextSha256": "6d2065c71d46fefc9c36525d169c91ec63f70753c0a3dc1b4bce84758e469305",
    "nodes": [
      {
        "tag": "p",
        "children": [
          {
            "text": "良い物件を購入できても、その後の「賃貸管理（運営）」を失敗すれば、投資は成功しません。 特に遠方の物件を持つ場合や、ご自身が多忙な場合、運営の実務を代行してくれる「賃貸管理会社」は、あなたの投資成果を左右する最も重要なパートナーとなります。",
          },
        ],
      },
      {
        "tag": "p",
        "children": [
          {
            "text": "管理会社を選ぶ際、「管理手数料が安いから」という理由だけで選ぶのは非常に危険です。 本当に見るべきは、以下の3つのポイントです。",
          },
        ],
      },
      {
        "tag": "aside",
        "role": "learn",
        "children": [
          {
            "tag": "strong",
            "children": [
              {
                "text": "学習目標",
              },
            ],
          },
          {
            "tag": "ul",
            "children": [
              {
                "tag": "li",
                "children": [
                  {
                    "text": "物件購入後の「運営」を任せる管理会社の重要性を理解する。",
                  },
                ],
              },
              {
                "tag": "li",
                "children": [
                  {
                    "text": "管理会社を選ぶ際の3つの重要基準（リーシング力、管理の質、コスト）を学ぶ。",
                  },
                ],
              },
            ],
          },
        ],
      },
      {
        "tag": "h3",
        "children": [
          {
            "tag": "strong",
            "children": [
              {
                "text": "1. リーシング力（客付け・入居者募集の強さ）",
              },
            ],
          },
        ],
      },
      {
        "tag": "p",
        "children": [
          {
            "text": "空室が発生した際に、どれだけ「早く」「良い条件で」次の入居者を見つけてこられるか、という能力です。これが管理会社の最大の価値と言っても過言ではありません。",
          },
        ],
      },
      {
        "tag": "p",
        "children": [
          {
            "tag": "strong",
            "children": [
              {
                "text": "チェックポイント:",
              },
            ],
          },
        ],
      },
      {
        "tag": "ul",
        "children": [
          {
            "tag": "li",
            "children": [
              {
                "text": "広告（ポータルサイト）への掲載スピードや掲載内容はどうか？",
              },
            ],
          },
          {
            "tag": "li",
            "children": [
              {
                "text": "地元の他の不動産仲介会社（客付け店）とのネットワークは広いか？（自社だけで抱え込もうとしていないか）",
              },
            ],
          },
          {
            "tag": "li",
            "children": [
              {
                "text": "そのエリアの賃貸市場（家賃相場、繁忙期）を熟知しているか？",
              },
            ],
          },
        ],
      },
      {
        "tag": "h3",
        "children": [
          {
            "tag": "strong",
            "children": [
              {
                "tag": "strong",
                "children": [
                  {
                    "text": "2. 管理の質（入居者対応・建物維持）",
                  },
                ],
              },
            ],
          },
        ],
      },
      {
        "tag": "p",
        "children": [
          {
            "text": "家賃の集金、滞納者への督促、入居者からのクレーム対応、退去時の立ち会い・原状回復、建物の清掃・点検など、日々の運営業務の質です。",
          },
        ],
      },
      {
        "tag": "p",
        "children": [
          {
            "tag": "strong",
            "children": [
              {
                "text": "チェックポイント:",
              },
            ],
          },
        ],
      },
      {
        "tag": "ul",
        "children": [
          {
            "tag": "li",
            "children": [
              {
                "text": "家賃滞納時の督促フローは明確か？",
              },
            ],
          },
          {
            "tag": "li",
            "children": [
              {
                "text": "設備故障（例：エアコンが壊れた）などの際、24時間対応窓口があるか？",
              },
            ],
          },
          {
            "tag": "li",
            "children": [
              {
                "text": "オーナーへの報告（月次収支報告、入居者トラブルなど）は迅速かつ丁寧か？",
              },
            ],
          },
        ],
      },
      {
        "tag": "h3",
        "children": [
          {
            "tag": "strong",
            "children": [
              {
                "tag": "strong",
                "children": [
                  {
                    "text": "3. コスト（管理手数料と業務範囲）",
                  },
                ],
              },
            ],
          },
        ],
      },
      {
        "tag": "p",
        "children": [
          {
            "text": "管理会社に支払う費用です。一般的に「家賃収入の5%」が相場ですが、その「中身」が重要です。",
          },
        ],
      },
      {
        "tag": "p",
        "children": [
          {
            "tag": "strong",
            "children": [
              {
                "text": "チェックポイント:",
              },
            ],
          },
        ],
      },
      {
        "tag": "ul",
        "children": [
          {
            "tag": "li",
            "children": [
              {
                "tag": "strong",
                "children": [
                  {
                    "text": "「管理手数料（例：5%）」に、どこまでの業務が含まれていますか？",
                  },
                ],
              },
            ],
          },
          {
            "tag": "li",
            "children": [
              {
                "text": "（例）入居者募集時の「広告料（AD）」や「仲介手数料」は、管理手数料とは別に発生しますか？",
              },
            ],
          },
          {
            "tag": "li",
            "children": [
              {
                "text": "（例）入居者退去時の「原状回復工事」は、その管理会社が指定する業者でしか行えませんか？（高額な工事費を請求されないか）",
              },
            ],
          },
          {
            "tag": "li",
            "children": [
              {
                "text": "（例）契約更新時の「更新事務手数料」はオーナーと入居者、どちらの負担ですか？",
              },
            ],
          },
        ],
      },
      {
        "tag": "aside",
        "role": "product",
        "children": [
          {
            "tag": "strong",
            "children": [
              {
                "text": "プロパリー活用ポイント",
              },
            ],
          },
          {
            "tag": "p",
            "children": [
              {
                "text": "どの管理会社を選んだとしても、毎月の収支（家賃収入、管理手数料、修繕費など）を正確に記録・把握することが不可欠です。",
              },
            ],
          },
          {
            "tag": "p",
            "children": [
              {
                "text": "プロパリーの「",
              },
              {
                "tag": "strong",
                "children": [
                  {
                    "text": "不動産管理機能",
                  },
                ],
              },
              {
                "text": "」を使えば、管理会社から送られてくる月次の収支報告書（明細）をアプリに入力するだけで、物件ごとの収支が自動でグラフ化されます。",
              },
            ],
          },
          {
            "tag": "p",
            "children": [
              {
                "text": "複数の物件を別々の管理会社に任せていても、アプリ上で一元管理できるため、どの物件（どの管理会社）が最も収益を上げているかを比較・分析できます。",
              },
            ],
          },
          {
            "tag": "p",
            "children": [
              {
                "text": "※保有物件の登録が必要です",
              },
            ],
          },
        ],
      },
      {
        "tag": "aside",
        "role": "summary",
        "children": [
          {
            "tag": "strong",
            "children": [
              {
                "text": "学習ポイントまとめ",
              },
            ],
          },
          {
            "tag": "p",
            "children": [
              {
                "text": "管理会社選びは",
              },
              {
                "tag": "strong",
                "children": [
                  {
                    "text": "「コスト（安さ）」",
                  },
                ],
              },
              {
                "text": "ではなく",
              },
              {
                "tag": "strong",
                "children": [
                  {
                    "text": "「収益の最大化（リーシング力）」",
                  },
                ],
              },
              {
                "text": "で選ぶ。",
              },
            ],
          },
          {
            "tag": "p",
            "children": [
              {
                "text": "手数料が安くても、空室期間が3ヶ月続く管理会社より、手数料が高くても1ヶ月で決めてくれる管理会社の方が、トータルの収益は高くなる。",
              },
            ],
          },
          {
            "tag": "p",
            "children": [
              {
                "text": "「手数料5%」という数字だけでなく、「業務範囲」と「別途発生する費用」を契約前に必ず確認する。",
              },
            ],
          },
        ],
      },
      {
        "tag": "p",
        "children": [
          {
            "text": " 「運営」のパートナー（管理会社）の選び方を学んだ次は、あなたの「購入」をサポートする、もう一人の重要なパートナー「不動産エージェント」の見極め方について学びましょう。",
          },
        ],
      },
      {
        "tag": "hr",
        "children": [],
      },
    ],
  },
  "intermediate-7": {
    "sourceUrl": "https://propally.co.jp/journal/lp/intermediate-7/",
    "sourceTitle": "「良い不動産営業マン」の見極め方と付き合い方",
    "acquiredAt": "2026-10-05T07:21:41.364Z",
    "sourceTextSha256": "63e1b9f5e952fd6aee014757dbbef34fed9fe70db5fa135b71c5ded49bf23cd0",
    "nodes": [
      {
        "tag": "p",
        "children": [
          {
            "text": "不動産投資は、購入後の「管理会社」と同じくらい、購入時の「",
          },
          {
            "tag": "strong",
            "children": [
              {
                "text": "不動産営業マン",
              },
            ],
          },
          {
            "text": "（担当者）」が重要です。彼らは、あなたの投資戦略を理解し、成功に導くパートナーとなり得ます。",
          },
        ],
      },
      {
        "tag": "p",
        "children": [
          {
            "text": "しかし、中には自社の利益（仲介手数料）を優先し、投資家のためにならない物件を勧めてくる担当者がいるのも事実です。",
          },
        ],
      },
      {
        "tag": "aside",
        "role": "learn",
        "children": [
          {
            "tag": "strong",
            "children": [
              {
                "text": "学習目標",
              },
            ],
          },
          {
            "tag": "ul",
            "children": [
              {
                "tag": "li",
                "children": [
                  {
                    "text": "投資家にとって「良い不動産営業マン」とは何か、その定義（単なる営業マンとの違い）を理解する。",
                  },
                ],
              },
              {
                "tag": "li",
                "children": [
                  {
                    "text": "不動産営業マンの質を見極めるための「魔法の質問」を学ぶ。",
                  },
                ],
              },
              {
                "tag": "li",
                "children": [
                  {
                    "text": "複数の不動産営業マンを比較検討する重要性を知る。",
                  },
                ],
              },
            ],
          },
        ],
      },
      {
        "tag": "h3",
        "children": [
          {
            "text": "1. ",
          },
          {
            "tag": "strong",
            "children": [
              {
                "text": "投資家にとって「良い不動産営業マン」とは？",
              },
            ],
          },
        ],
      },
      {
        "tag": "p",
        "children": [
          {
            "tag": "strong",
            "children": [
              {
                "text": "悪い例:",
              },
            ],
          },
          {
            "text": "「これは人気エリアで」「すぐ売れますよ」と、メリットばかりを強調し、契約を急がせる。",
          },
        ],
      },
      {
        "tag": "p",
        "children": [
          {
            "tag": "strong",
            "children": [
              {
                "text": "良い例:",
              },
            ],
          },
          {
            "text": " あなたの投資目標（キャッシュフロー重視、節税目的、将来の資産価値など）を深くヒアリングし、その目標に沿った物件の",
          },
          {
            "tag": "strong",
            "children": [
              {
                "text": "メリットと「リスク」の両方",
              },
            ],
          },
          {
            "text": "を具体的に説明してくれる。",
          },
        ],
      },
      {
        "tag": "h3",
        "children": [
          {
            "text": "2. ",
          },
          {
            "tag": "strong",
            "children": [
              {
                "text": "良い不動産営業マンを見極める「魔法の質問」",
              },
            ],
          },
        ],
      },
      {
        "tag": "p",
        "children": [
          {
            "text": "不動産営業マンと面談したら、以下の質問をしてみてください。その回答で、彼が「あなたのパートナー」になり得るかが見えてきます。",
          },
        ],
      },
      {
        "tag": "p",
        "children": [
          {
            "tag": "strong",
            "children": [
              {
                "text": "質問1：「この物件の『最大の懸念点（リスク）』は何ですか？」",
              },
            ],
          },
          {
            "tag": "br",
            "children": [],
          },
          {
            "text": "→ リスクを即座に、具体的に答えられるか？「特にありません」と答える担当者は信用できません",
          },
        ],
      },
      {
        "tag": "p",
        "children": [
          {
            "tag": "strong",
            "children": [
              {
                "text": "質問2：「この物件の『実質利回り』と『年間キャッシュフロー』の試算（シミュレーション）を見せてください」",
              },
            ],
          },
          {
            "tag": "br",
            "children": [],
          },
          {
            "text": "→ 表面利回りしか話さない担当者ではないか？ 経費や空室リスクを考慮した試算を出せるか？",
          },
        ],
      },
      {
        "tag": "p",
        "children": [
          {
            "tag": "strong",
            "children": [
              {
                "text": "質問3：「なぜ、前のオーナーはこの物件を売るのですか？」",
              },
            ],
          },
          {
            "tag": "br",
            "children": [],
          },
          {
            "text": "→ 答えをはぐらかさないか？ 売却理由（例：資産の入れ替え、デッドクロス発生）から、物件の隠れた問題が見えることがあります",
          },
        ],
      },
      {
        "tag": "h3",
        "children": [
          {
            "tag": "strong",
            "children": [
              {
                "text": "複数の不動産営業マンを比較することが鉄則",
              },
            ],
          },
        ],
      },
      {
        "tag": "p",
        "children": [
          {
            "text": "素晴らしい不動産営業マンは存在しますが、最初から一人に絞り込むのは危険です。A社は融資に強い、B社は特定のエリアの未公開物件に強いなど、それぞれ得意分野が異なります。",
          },
        ],
      },
      {
        "tag": "p",
        "children": [
          {
            "text": "複数の不動産営業マンと接点を持ち、その提案を比較検討することが、あなたの投資成功率を高める最短の道です。",
          },
        ],
      },
      {
        "tag": "aside",
        "role": "product",
        "children": [
          {
            "tag": "strong",
            "children": [
              {
                "text": "プロパリー活用ポイント",
              },
            ],
          },
          {
            "tag": "p",
            "children": [
              {
                "text": "プロパリーは、自ら物件を売らない",
              },
              {
                "tag": "strong",
                "children": [
                  {
                    "text": "「中立的」なプラットフォーム",
                  },
                ],
              },
              {
                "text": "です。 だからこそ、ユーザー（あなた）が最適なパートナーを見つけられる機能を提供しています。",
              },
            ],
          },
          {
            "tag": "p",
            "children": [
              {
                "tag": "strong",
                "children": [
                  {
                    "text": "また、プロパリーでは不動産営業マンの中でも厳しい審査を通過した人だけを「プロフェッショナル」として登録しています。",
                  },
                ],
              },
            ],
          },
          {
            "tag": "p",
            "children": [
              {
                "text": "あなたの投資戦略や希望条件を登録しておくと、不動産投資のプロから「物件の提案」や「査定オファー」が届きます。",
              },
            ],
          },
          {
            "tag": "p",
            "children": [
              {
                "text": "オファーを待つだけでなく、不動産投資のプロのプロフィールや得意分野を見て、あなたから能動的に話を聞きに行くことも可能です。",
              },
            ],
          },
          {
            "tag": "p",
            "children": [
              {
                "text": "プロパリー上で複数のプロを比較し、最も信頼できるパートナーを見つけましょう。",
              },
            ],
          },
        ],
      },
      {
        "tag": "aside",
        "role": "summary",
        "children": [
          {
            "tag": "strong",
            "children": [
              {
                "text": "学習ポイントまとめ",
              },
            ],
          },
          {
            "tag": "ul",
            "children": [
              {
                "tag": "li",
                "children": [
                  {
                    "text": "良い営業マンは",
                  },
                  {
                    "tag": "strong",
                    "children": [
                      {
                        "text": "「物件を売る人」ではなく、「投資家の目標達成をサポートするパートナー」",
                      },
                    ],
                  },
                  {
                    "text": "である。",
                  },
                ],
              },
              {
                "tag": "li",
                "children": [
                  {
                    "text": "「リスク」と「キャッシュフロー」について具体的な質問を投げかけ、その返答で相手の専門性を見極める。",
                  },
                ],
              },
              {
                "tag": "li",
                "children": [
                  {
                    "text": "一人の担当者だけを信じ込まず、プロパリーの機能も活用して、必ず複数の営業マンを比較検討する。",
                  },
                ],
              },
            ],
          },
        ],
      },
      {
        "tag": "p",
        "children": [
          {
            "text": "お疲れさまでした！ これで中級編で学ぶべき「実践スキル」はすべて完了です。 最後に、これまで学んだすべての知識（エリア、現地、価格、融資、税務）を総動員して行う「シミュレーション」の具体的な活用術を、番外編として学びましょう。",
          },
        ],
      },
      {
        "tag": "hr",
        "children": [],
      },
    ],
  },
  "intermediate-8": {
    "sourceUrl": "https://propally.co.jp/journal/lp/intermediate-8/",
    "sourceTitle": "番外編：プロパリー　シミュレーション徹底活用術（購入編）",
    "acquiredAt": "2026-10-05T07:21:41.515Z",
    "sourceTextSha256": "4d43b0c1f2d06e6eabb77ab846363c5313cc19b3c6f6ecc26c7091690ca520db",
    "nodes": [
      {
        "tag": "p",
        "children": [
          {
            "text": "お疲れさまでした。中級編では「エリア選定」「現地調査」「融資」「税務」など、多くの実践スキルを学んできました。",
          },
        ],
      },
      {
        "tag": "p",
        "children": [
          {
            "text": "なぜ、シミュレーションの話は最後（番外編）なのか？ それは、",
          },
          {
            "tag": "strong",
            "children": [
              {
                "text": "シミュレーションとは、あなたが中級編で学んだ「すべての知識」を「数値」に落とし込み、投資判断を下すための「最終兵器」",
              },
            ],
          },
          {
            "text": "だからです。",
          },
        ],
      },
      {
        "tag": "aside",
        "role": "learn",
        "children": [
          {
            "tag": "strong",
            "children": [
              {
                "text": "学習目標",
              },
            ],
          },
          {
            "tag": "ul",
            "children": [
              {
                "tag": "li",
                "children": [
                  {
                    "text": "中級編で学んだ知識（エリア、現地、融資、税務など）を、シミュレーションに入力する「変数」として理解する。",
                  },
                ],
              },
              {
                "tag": "li",
                "children": [
                  {
                    "text": "「ストレス（悪化）テスト」の重要性を学び、投資判断の精度を極限まで高める。",
                  },
                ],
              },
            ],
          },
        ],
      },
      {
        "tag": "h3",
        "children": [
          {
            "tag": "strong",
            "children": [
              {
                "text": "シミュレーションは「知識の精度」を反映する鏡",
              },
            ],
          },
        ],
      },
      {
        "tag": "p",
        "children": [
          {
            "text": "シミュレーション機能は、ただ数字を入れれば良いというものではありません。入力する「変数」の精度が低いと、導き出される結果も信頼できません。",
          },
        ],
      },
      {
        "tag": "ul",
        "children": [
          {
            "tag": "li",
            "children": [
              {
                "tag": "strong",
                "children": [
                  {
                    "text": "「税務」",
                  },
                ],
              },
              {
                "text": "の知識は → 「",
              },
              {
                "tag": "strong",
                "children": [
                  {
                    "text": "構造（減価償却）",
                  },
                ],
              },
              {
                "text": "」や「",
              },
              {
                "tag": "strong",
                "children": [
                  {
                    "text": "建物価格の割合",
                  },
                ],
              },
              {
                "text": "」を正しく入力するために使います。",
              },
            ],
          },
          {
            "tag": "li",
            "children": [
              {
                "tag": "strong",
                "children": [
                  {
                    "text": "「エリア選定」",
                  },
                ],
              },
              {
                "text": "の知識は → 「",
              },
              {
                "tag": "strong",
                "children": [
                  {
                    "text": "空室率",
                  },
                ],
              },
              {
                "text": "」「",
              },
              {
                "tag": "strong",
                "children": [
                  {
                    "text": "将来の家賃下落率",
                  },
                ],
              },
              {
                "text": "」の予測精度を高めます。",
              },
            ],
          },
          {
            "tag": "li",
            "children": [
              {
                "tag": "strong",
                "children": [
                  {
                    "text": "「現地調査」",
                  },
                ],
              },
              {
                "text": "の知識は → 「",
              },
              {
                "tag": "strong",
                "children": [
                  {
                    "text": "修繕費",
                  },
                ],
              },
              {
                "text": "（外壁のヒビなど）」や「",
              },
              {
                "tag": "strong",
                "children": [
                  {
                    "text": "管理の質",
                  },
                ],
              },
              {
                "text": "」の予測精度を高めます。",
              },
            ],
          },
          {
            "tag": "li",
            "children": [
              {
                "tag": "strong",
                "children": [
                  {
                    "text": "「融資戦略」",
                  },
                ],
              },
              {
                "text": "の知識は → 「",
              },
              {
                "tag": "strong",
                "children": [
                  {
                    "text": "金利",
                  },
                ],
              },
              {
                "text": "」「",
              },
              {
                "tag": "strong",
                "children": [
                  {
                    "text": "返済期間",
                  },
                ],
              },
              {
                "text": "」「",
              },
              {
                "tag": "strong",
                "children": [
                  {
                    "text": "自己資金額",
                  },
                ],
              },
              {
                "text": "」という最も重要な変数を設定するために使います。",
              },
            ],
          },
        ],
      },
      {
        "tag": "h3",
        "children": [
          {
            "tag": "strong",
            "children": [
              {
                "tag": "strong",
                "children": [
                  {
                    "text": "【最重要】ストレス（悪化）テストを実行する",
                  },
                ],
              },
            ],
          },
        ],
      },
      {
        "tag": "p",
        "children": [
          {
            "text": "これが中級者と初心者の決定的な違いです。 良い投資家は、エージェントが提示する「楽観的なシミュレーション（満室想定など）」を疑い、必ず「最悪の事態」を想定したテスト（ストレス（悪化）テスト）を自ら行います。",
          },
        ],
      },
      {
        "tag": "p",
        "children": [
          {
            "tag": "strong",
            "children": [
              {
                "text": "Propallyのシミュレーションで、以下の変数を「わざと悪化」させてみてください。",
              },
            ],
          },
        ],
      },
      {
        "tag": "ul",
        "children": [
          {
            "tag": "li",
            "children": [
              {
                "tag": "strong",
                "children": [
                  {
                    "text": "「金利」を +1% してみる",
                  },
                ],
              },
            ],
          },
          {
            "tag": "li",
            "children": [
              {
                "tag": "strong",
                "children": [
                  {
                    "text": "「空室率」を 5% → 15% にしてみる",
                  },
                ],
              },
            ],
          },
          {
            "tag": "li",
            "children": [
              {
                "tag": "strong",
                "children": [
                  {
                    "text": "「家賃」を 5% 下落させてみる",
                  },
                ],
              },
            ],
          },
        ],
      },
      {
        "tag": "aside",
        "role": "summary",
        "children": [
          {
            "tag": "strong",
            "children": [
              {
                "text": "学習ポイントまとめ",
              },
            ],
          },
          {
            "tag": "p",
            "children": [
              {
                "text": "シミュレーションは",
              },
              {
                "tag": "strong",
                "children": [
                  {
                    "text": "「魔法の箱」",
                  },
                ],
              },
              {
                "text": "ではなく、これまで学んだ",
              },
              {
                "tag": "strong",
                "children": [
                  {
                    "text": "「知識の精度」を反映する「鏡」",
                  },
                ],
              },
              {
                "text": "である。",
              },
            ],
          },
          {
            "tag": "p",
            "children": [
              {
                "text": "投資判断は、必ず",
              },
              {
                "tag": "strong",
                "children": [
                  {
                    "text": "「ストレス（悪化）テスト」",
                  },
                ],
              },
              {
                "text": "を行い、「最悪の事態」でも耐えられるかを基準に行う。",
              },
            ],
          },
        ],
      },
      {
        "tag": "p",
        "children": [
          {
            "text": "これで中級編はすべて修了です。おめでとうございます！ あなたは不動産投資の「実践スキル」を身につけました。 次はいよいよ「上級編」です。すでに物件を保有している投資家が、どうやって「収益を最大化」し、「ポートフォリオを管理」しているのか、プロの戦略を学びましょう。",
          },
        ],
      },
      {
        "tag": "hr",
        "children": [],
      },
    ],
  },
  "advanced-1": {
    "sourceUrl": "https://propally.co.jp/journal/lp/advanced-1/",
    "sourceTitle": "保有物件の「空室対策」実践テクニック5選」",
    "acquiredAt": "2026-10-05T07:21:41.518Z",
    "sourceTextSha256": "bcd1b626313a20196556f64aa7f303abb9bb67034d13d0c5605bee3af448bc49",
    "nodes": [
      {
        "tag": "p",
        "children": [
          {
            "text": "物件を保有するオーナーにとって、最大の敵は「空室」です。家賃収入がゼロになるだけでなく、管理費やローン返済は変わらず発生し、キャッシュフローを一気に悪化させます。",
          },
        ],
      },
      {
        "tag": "p",
        "children": [
          {
            "text": "管理会社に「募集を頑張ってください」と伝えるだけでは不十分です。オーナー自身が「空室の原因は何か？」を分析し、主体的に対策を打つ必要があります。",
          },
        ],
      },
      {
        "tag": "p",
        "children": [
          {
            "text": "コストがかからない順に、実践的な5つのテクニックをご紹介します。",
          },
        ],
      },
      {
        "tag": "aside",
        "role": "learn",
        "children": [
          {
            "tag": "strong",
            "children": [
              {
                "text": "学習目標",
              },
            ],
          },
          {
            "tag": "ul",
            "children": [
              {
                "tag": "li",
                "children": [
                  {
                    "text": "空室が発生した際に、オーナーが「コストをかけない対策」から「コストをかける対策」まで、優先順位をつけて実行できるようになる。",
                  },
                ],
              },
              {
                "tag": "li",
                "children": [
                  {
                    "text": "管理会社任せにせず、オーナー主導でリーシング（客付け）を改善する具体的な行動を学ぶ。",
                  },
                ],
              },
            ],
          },
        ],
      },
      {
        "tag": "h3",
        "children": [
          {
            "text": "1. ",
          },
          {
            "tag": "strong",
            "children": [
              {
                "text": "【コスト：低】募集条件の見直し",
              },
            ],
          },
        ],
      },
      {
        "tag": "p",
        "children": [
          {
            "text": "まずは「価格」と「初期費用」で、競合（ライバル物件）に対する優位性を確保します。",
          },
        ],
      },
      {
        "tag": "p",
        "children": [
          {
            "tag": "strong",
            "children": [
              {
                "text": "具体策:",
              },
            ],
          },
        ],
      },
      {
        "tag": "p",
        "children": [
          {
            "tag": "strong",
            "children": [
              {
                "text": "家賃・管理費の調整:",
              },
            ],
          },
          {
            "text": " 周辺の類似物件の「現在の募集家賃（相場）」を調査し、1,000円単位で調整します。",
          },
        ],
      },
      {
        "tag": "p",
        "children": [
          {
            "tag": "strong",
            "children": [
              {
                "text": "敷金・礼金の見直し:",
              },
            ],
          },
          {
            "text": " 「礼金ゼロ」や「敷金ゼロ」（ハウスクリーニング代は別途請求など）にし、入居時の初期費用（ハードル）を下げます。",
          },
        ],
      },
      {
        "tag": "p",
        "children": [
          {
            "tag": "strong",
            "children": [
              {
                "text": "フリーレントの導入:",
              },
            ],
          },
          {
            "text": " 「最初の1ヶ月分の家賃無料」など。入居者は初期費用を抑えられ、オーナーは家賃相場を下げずに募集できます。",
          },
        ],
      },
      {
        "tag": "h3",
        "children": [
          {
            "tag": "strong",
            "children": [
              {
                "text": "2.【コスト：中】広告料（AD）戦略",
              },
            ],
          },
        ],
      },
      {
        "tag": "p",
        "children": [
          {
            "text": "まずは「価格」と「初期費用」で、競合（ライバル物件）に対する優位性を確保します。",
          },
        ],
      },
      {
        "tag": "p",
        "children": [
          {
            "tag": "strong",
            "children": [
              {
                "text": "具体策:",
              },
            ],
          },
        ],
      },
      {
        "tag": "ul",
        "children": [
          {
            "tag": "li",
            "children": [
              {
                "tag": "strong",
                "children": [
                  {
                    "text": "家賃・管理費の調整:",
                  },
                ],
              },
              {
                "text": " 周辺の類似物件の「現在の募集家賃（相場）」を調査し、1,000円単位で調整します。",
              },
            ],
          },
          {
            "tag": "li",
            "children": [
              {
                "tag": "strong",
                "children": [
                  {
                    "text": "敷金・礼金の見直し:",
                  },
                ],
              },
              {
                "text": " 「礼金ゼロ」や「敷金ゼロ」（ハウスクリーニング代は別途請求など）にし、入居時の初期費用（ハードル）を下げます。",
              },
            ],
          },
          {
            "tag": "li",
            "children": [
              {
                "tag": "strong",
                "children": [
                  {
                    "text": "フリーレントの導入:",
                  },
                ],
              },
              {
                "text": " 「最初の1ヶ月分の家賃無料」など。入居者は初期費用を抑えられ、オーナーは家賃相場を下げずに募集できます。",
              },
            ],
          },
        ],
      },
      {
        "tag": "h3",
        "children": [
          {
            "tag": "strong",
            "children": [
              {
                "text": "3.【コスト：中】軽微な設備投資（プチリフォーム）",
              },
            ],
          },
        ],
      },
      {
        "tag": "p",
        "children": [
          {
            "text": "入居者が「最低限これだけは欲しい」と考える設備をピンポイントで追加し、内見時の印象を良くします。",
          },
        ],
      },
      {
        "tag": "p",
        "children": [
          {
            "tag": "strong",
            "children": [
              {
                "text": "具体策:",
              },
            ],
          },
        ],
      },
      {
        "tag": "ul",
        "children": [
          {
            "tag": "li",
            "children": [
              {
                "text": "宅配ボックスの設置（一棟ものの場合、競合と大きな差別化になる）",
              },
            ],
          },
          {
            "tag": "li",
            "children": [
              {
                "text": "モニター付きインターホンの設置（セキュリティ意識の高まりに対応）",
              },
            ],
          },
          {
            "tag": "li",
            "children": [
              {
                "text": "独立洗面台の設置（特に女性ターゲットの場合）",
              },
            ],
          },
          {
            "tag": "li",
            "children": [
              {
                "text": "温水洗浄便座への交換",
              },
            ],
          },
        ],
      },
      {
        "tag": "h3",
        "children": [
          {
            "tag": "strong",
            "children": [
              {
                "text": "4.【コスト：低〜中】募集ターゲットの拡大",
              },
            ],
          },
        ],
      },
      {
        "tag": "p",
        "children": [
          {
            "text": "これまで断っていた層を受け入れることで、募集の「窓口」そのものを広げます。",
          },
        ],
      },
      {
        "tag": "p",
        "children": [
          {
            "tag": "strong",
            "children": [
              {
                "text": "具体策:",
              },
            ],
          },
        ],
      },
      {
        "tag": "ul",
        "children": [
          {
            "tag": "li",
            "children": [
              {
                "text": "ペット可（敷金を1ヶ月分増やすなどの条件付き）",
              },
            ],
          },
          {
            "tag": "li",
            "children": [
              {
                "text": "事務所（SOHO）利用可",
              },
            ],
          },
          {
            "tag": "li",
            "children": [
              {
                "text": "（エリアによるが）外国人入居者や、高齢者の受け入れ検討",
              },
            ],
          },
        ],
      },
      {
        "tag": "h3",
        "children": [
          {
            "tag": "strong",
            "children": [
              {
                "text": "5.【コスト：高】ターゲット層の変更（リノベーション）",
              },
            ],
          },
        ],
      },
      {
        "tag": "p",
        "children": [
          {
            "text": "小手先の対策では空室が埋まらない場合、抜本的に「間取り」や「デザイン」を変更し、物件の価値そのものを高めます。",
          },
        ],
      },
      {
        "tag": "p",
        "children": [
          {
            "tag": "strong",
            "children": [
              {
                "text": "具体策:",
              },
            ],
          },
        ],
      },
      {
        "tag": "ul",
        "children": [
          {
            "tag": "li",
            "children": [
              {
                "text": "（例）3DKの間取り → 広いリビングを持つ2LDKに変更し、新婚・カップル層を狙う。",
              },
            ],
          },
          {
            "tag": "li",
            "children": [
              {
                "text": "（例）和室 → 洋室（フローリング）へ変更する。",
              },
            ],
          },
        ],
      },
      {
        "tag": "aside",
        "role": "summary",
        "children": [
          {
            "tag": "strong",
            "children": [
              {
                "text": "学習ポイントまとめ",
              },
            ],
          },
          {
            "tag": "p",
            "children": [
              {
                "text": "空室対策は",
              },
              {
                "tag": "strong",
                "children": [
                  {
                    "text": "「管理会社任せ」にしない",
                  },
                ],
              },
              {
                "text": "。オーナーが「コスト」と「効果」を天秤にかけ、主体的に判断する。",
              },
            ],
          },
          {
            "tag": "p",
            "children": [
              {
                "text": "まずは「募集条件」や「広告戦略」など、低コストで実行できる施策から試し、それでも埋まらなければ「設備投資」や「リノベーション」を検討する。",
              },
            ],
          },
        ],
      },
      {
        "tag": "p",
        "children": [
          {
            "text": "空室対策の最終手段でもある「リノベーション」は、大きなコストがかかります。 次は、そのコストが果たして「儲かる投資」になるのか、「投資対効果（ROI）」を算出する方法について詳しく学びましょう。",
          },
        ],
      },
      {
        "tag": "hr",
        "children": [],
      },
    ],
  },
  "advanced-2": {
    "sourceUrl": "https://propally.co.jp/journal/lp/advanced-2/",
    "sourceTitle": "「リノベーション」の投資対効果（ROI）算出方法",
    "acquiredAt": "2026-10-05T07:21:41.474Z",
    "sourceTextSha256": "049dd59ba6f295bff6b76ef77eec124c8d2dd974bab656246f1dd54d354bd84b",
    "nodes": [
      {
        "tag": "p",
        "children": [
          {
            "text": "リノベーション（大規模修繕・改修）は、空室対策の中でも最もコストがかかる施策です。だからこそ、「なんとなく古くなったから」という理由で実行してはいけません。 それは",
          },
          {
            "tag": "strong",
            "children": [
              {
                "text": "「コスト（経費）」ではなく、リターンを目的とした「投資」です。",
              },
            ],
          },
          {
            "text": "ここでは、その投資対効果を測る2つの重要な指標を解説します。",
          },
        ],
      },
      {
        "tag": "aside",
        "role": "learn",
        "children": [
          {
            "tag": "strong",
            "children": [
              {
                "text": "学習目標",
              },
            ],
          },
          {
            "tag": "ul",
            "children": [
              {
                "tag": "li",
                "children": [
                  {
                    "text": "「なんとなくキレイにする」という感覚的な判断から脱却し、「投資対効果（ROI）」と「回収期間」を数値で算出できるようになる。",
                  },
                ],
              },
              {
                "tag": "li",
                "children": [
                  {
                    "text": "リノベーションが「家賃上昇」と「資産価値（売却価格）上昇」のどちらに寄与するのかを意識して、投資判断を下す。",
                  },
                ],
              },
            ],
          },
        ],
      },
      {
        "tag": "h3",
        "children": [
          {
            "tag": "strong",
            "children": [
              {
                "text": "1. 投資対効果（ROI）の算出",
              },
            ],
          },
        ],
      },
      {
        "tag": "p",
        "children": [
          {
            "text": "投下した資本（リノベーション費用）に対して、どれだけのリターン（家賃上昇額）が年間であるかを示します。",
          },
          {
            "tag": "br",
            "children": [],
          },
          {
            "text": "計算式は、",
          },
        ],
      },
      {
        "tag": "p",
        "children": [
          {
            "tag": "strong",
            "children": [
              {
                "text": "ROI（%） = ｛（リノベーション後の想定家賃 － 現在の家賃）× 12ヶ月｝ ÷ リノベーション費用 × 100",
              },
            ],
          },
        ],
        "role": "formula",
      },
      {
        "tag": "p",
        "children": [
          {
            "tag": "strong",
            "children": [
              {
                "text": "（例）",
              },
            ],
          },
          {
            "text": " 200万円の費用をかけてリノベーションし、家賃が月額1万円上昇した場合",
          },
        ],
      },
      {
        "tag": "p",
        "children": [
          {
            "text": "年間家賃上昇額： 1万円 × 12ヶ月 = 12万円",
          },
        ],
      },
      {
        "tag": "p",
        "children": [
          {
            "tag": "strong",
            "children": [
              {
                "text": "ROI = 12万円 ÷ 200万円 × 100 = 6%",
              },
            ],
          },
        ],
      },
      {
        "tag": "p",
        "children": [
          {
            "text": "この",
          },
          {
            "tag": "strong",
            "children": [
              {
                "text": "「ROI 6%」",
              },
            ],
          },
          {
            "text": "は、あなたが他の投資（例：新しい物件の購入）で得られる利回りと比較して、見合うものかどうかを判断する基準となります。",
          },
        ],
      },
      {
        "tag": "h3",
        "children": [
          {
            "tag": "strong",
            "children": [
              {
                "tag": "strong",
                "children": [
                  {
                    "text": "2. 投資回収期間（Payback Period）の算出",
                  },
                ],
              },
            ],
          },
        ],
      },
      {
        "tag": "p",
        "children": [
          {
            "text": "投下したリノベーション費用を、上昇した家賃だけで何年かければ回収できるかを示します。",
          },
          {
            "tag": "br",
            "children": [],
          },
          {
            "text": "計算式は、",
          },
        ],
      },
      {
        "tag": "p",
        "children": [
          {
            "tag": "strong",
            "children": [
              {
                "text": "回収期間（年） = リノベーション費用 ÷ （年間の家賃上昇額）",
              },
            ],
          },
        ],
        "role": "formula",
      },
      {
        "tag": "p",
        "children": [
          {
            "tag": "strong",
            "children": [
              {
                "text": "（例）",
              },
            ],
          },
          {
            "text": " 上記と同じく、200万円の費用で年間12万円の家賃上昇の場合",
          },
        ],
      },
      {
        "tag": "p",
        "children": [
          {
            "tag": "strong",
            "children": [
              {
                "text": "回収期間 = 200万円 ÷ 12万円 = 約16.7年",
              },
            ],
          },
        ],
      },
      {
        "tag": "p",
        "children": [
          {
            "text": "この「16.7年」が、あなたの",
          },
          {
            "tag": "strong",
            "children": [
              {
                "text": "想定保有期間",
              },
            ],
          },
          {
            "text": "よりも短いかどうかが重要です。 もし「5年後に売却する」予定の物件に16.7年かかる投資をしても、家賃上昇分だけでは回収できません。この場合、そのリノベーションが「",
          },
          {
            "tag": "strong",
            "children": [
              {
                "text": "売却価格の上昇",
              },
            ],
          },
          {
            "text": "」にどれだけ寄与するか（例：200万円の投資で、売却価格が200万円以上上がるか）という視点で判断する必要があります。",
          },
        ],
      },
      {
        "tag": "h3",
        "children": [
          {
            "tag": "strong",
            "children": [
              {
                "tag": "strong",
                "children": [
                  {
                    "tag": "strong",
                    "children": [
                      {
                        "text": "税務上の注意点：「修繕費」 vs 「資本的支出」",
                      },
                    ],
                  },
                ],
              },
            ],
          },
        ],
      },
      {
        "tag": "p",
        "children": [
          {
            "text": "専門的な話ですが、リノベーション費用はその内容によって税務上の扱いが変わります。",
          },
        ],
      },
      {
        "tag": "p",
        "children": [
          {
            "tag": "strong",
            "children": [
              {
                "text": "修繕費:",
              },
            ],
          },
          {
            "text": " 原状回復や通常の維持管理（例：壁紙の張替え）。その年の「経費」として一括計上できます。",
          },
        ],
      },
      {
        "tag": "p",
        "children": [
          {
            "tag": "strong",
            "children": [
              {
                "text": "資本的支出:",
              },
            ],
          },
          {
            "text": " 建物の価値を高める、または耐用年数を延ばす工事（例：間取り変更、大規模な設備刷新）。「資産」として計上し、数年かけて「減価償却」していく必要があります。 どちらに該当するかで、その年のキャッシュフロー（税金額）が大きく変わるため、実行前に必ず税理士にご相談ください。",
          },
        ],
      },
      {
        "tag": "aside",
        "role": "product",
        "children": [
          {
            "tag": "strong",
            "children": [
              {
                "text": "プロパリー活用ポイント",
              },
            ],
          },
          {
            "tag": "p",
            "children": [
              {
                "text": "リノベーションによって家賃が上昇したら、プロパリーの「",
              },
              {
                "tag": "strong",
                "children": [
                  {
                    "text": "不動産管理（保有物件）",
                  },
                ],
              },
              {
                "text": "」機能で、新しい家賃収入と支出（工事費）を記録しましょう。",
              },
            ],
          },
          {
            "tag": "p",
            "children": [
              {
                "text": "実際のキャッシュフローがどれだけ改善したか、投資の「結果」を正確にトラッキングできます。",
              },
            ],
          },
          {
            "tag": "p",
            "children": [
              {
                "text": "また、リノベーション費用（資本的支出）を考慮した将来の「売却シミュレーション」も可能です。",
              },
            ],
          },
        ],
      },
      {
        "tag": "aside",
        "role": "summary",
        "children": [
          {
            "tag": "strong",
            "children": [
              {
                "text": "学習ポイントまとめ",
              },
            ],
          },
          {
            "tag": "p",
            "children": [
              {
                "text": "リノベーションは「感覚」ではなく「数値」で判断する。「ROI（利回り）」と「回収期間」を必ず計算する。",
              },
            ],
          },
          {
            "tag": "p",
            "children": [
              {
                "text": "「回収期間」が「想定保有期間」を上回る場合、その投資は「家賃上昇」ではなく「売却価格の上昇」に転嫁できなければ失敗となる。",
              },
            ],
          },
          {
            "tag": "p",
            "children": [
              {
                "text": "投資の「結果」は、必ず管理機能で記録し、投資判断が正しかったかを振り返る。",
              },
            ],
          },
        ],
      },
      {
        "tag": "p",
        "children": [
          {
            "text": " 物件の価値を最大化（または維持）する方法を学んだところで、次はいよいよ投資の「出口戦略」です。その物件を「いつ売るべきか」、最適なタイミングの見極め方について学びましょう。",
          },
        ],
      },
      {
        "tag": "hr",
        "children": [],
      },
    ],
  },
  "advanced-3": {
    "sourceUrl": "https://propally.co.jp/journal/lp/advanced-3/",
    "sourceTitle": "出口戦略（売却）の最適タイミングの見極め方",
    "acquiredAt": "2026-10-05T07:21:41.671Z",
    "sourceTextSha256": "4595ce2384be148e0fb44f6d4ec20f2b6a5354f71e253a40862a7ed52c9afa8a",
    "nodes": [
      {
        "tag": "p",
        "children": [
          {
            "text": "不動産投資は、売却して利益を確定させる（＝出口）までがワンセットです。購入時に「出口（いつ、いくらで売るか）」を想定できていない投資は、失敗する可能性が高まります。",
          },
        ],
      },
      {
        "tag": "p",
        "children": [
          {
            "text": "最適な売却タイミングは、以下の3つの観点から総合的に判断します。",
          },
        ],
      },
      {
        "tag": "aside",
        "role": "learn",
        "children": [
          {
            "tag": "strong",
            "children": [
              {
                "text": "学習目標",
              },
            ],
          },
          {
            "tag": "ul",
            "children": [
              {
                "tag": "li",
                "children": [
                  {
                    "text": "「なんとなく価格が上がったから」という感覚的な売却を避け、「税務」「財務」「市況」の3つの観点から、論理的に「売り時」を判断できるようになる。",
                  },
                ],
              },
              {
                "tag": "li",
                "children": [
                  {
                    "text": "特に「所有期間5年」の壁が税率に与える影響を理解する。",
                  },
                ],
              },
            ],
          },
        ],
      },
      {
        "tag": "h3",
        "children": [
          {
            "tag": "strong",
            "children": [
              {
                "text": "1. 税務（税率）：「5年の壁」を越えたか？",
              },
            ],
          },
        ],
      },
      {
        "tag": "p",
        "children": [
          {
            "text": "不動産を売却して得た利益（譲渡所得）にかかる税率は、その不動産の",
          },
          {
            "tag": "strong",
            "children": [
              {
                "text": "所有期間",
              },
            ],
          },
          {
            "text": "によって劇的に変わります。",
          },
        ],
      },
      {
        "tag": "p",
        "children": [
          {
            "tag": "strong",
            "children": [
              {
                "text": "短期譲渡所得:",
              },
            ],
          },
          {
            "text": " 所有期間が",
          },
          {
            "tag": "strong",
            "children": [
              {
                "text": "5年以下",
              },
            ],
          },
          {
            "text": "（売却した年の1月1日時点）の場合",
          },
        ],
      },
      {
        "tag": "p",
        "children": [
          {
            "text": "税率：",
          },
          {
            "tag": "strong",
            "children": [
              {
                "text": "約39.6%",
              },
            ],
          },
          {
            "text": " （所得税30.63% + 住民税9%）",
          },
        ],
      },
      {
        "tag": "p",
        "children": [
          {
            "tag": "strong",
            "children": [
              {
                "text": "長期譲渡所得:",
              },
            ],
          },
          {
            "text": " 所有期間が",
          },
          {
            "tag": "strong",
            "children": [
              {
                "text": "5年超",
              },
            ],
          },
          {
            "text": "の場合",
          },
        ],
      },
      {
        "tag": "p",
        "children": [
          {
            "text": "税率：",
          },
          {
            "tag": "strong",
            "children": [
              {
                "text": "約20.3%",
              },
            ],
          },
          {
            "text": " （所得税15.315% + 住民税5%）",
          },
        ],
      },
      {
        "tag": "p",
        "children": [
          {
            "text": "税率がほぼ半分になる「",
          },
          {
            "tag": "strong",
            "children": [
              {
                "text": "所有期間5年超え",
              },
            ],
          },
          {
            "text": "」は、売却タイミングを考える上での絶対的な基本セオリーです。焦って短期で売却すると、利益の約4割を税金で持っていかれます。",
          },
        ],
      },
      {
        "tag": "h3",
        "children": [
          {
            "tag": "strong",
            "children": [
              {
                "tag": "strong",
                "children": [
                  {
                    "tag": "strong",
                    "children": [
                      {
                        "text": "2. 市況（マーケット）：金利と不動産価格",
                      },
                    ],
                  },
                ],
              },
            ],
          },
        ],
      },
      {
        "tag": "p",
        "children": [
          {
            "text": "「世の中」が売り手と買い手、どちらに有利な状況かを判断します。",
          },
        ],
      },
      {
        "tag": "p",
        "children": [
          {
            "tag": "strong",
            "children": [
              {
                "text": "判断基準:",
              },
            ],
          },
        ],
      },
      {
        "tag": "p",
        "children": [
          {
            "tag": "strong",
            "children": [
              {
                "text": "金利動向:",
              },
            ],
          },
          {
            "text": " 「低金利」の時期は、買い手（次の投資家）がローンを組みやすいため、物件が売れやすく、価格も上がりやすい「売り手市場」です。",
          },
        ],
      },
      {
        "tag": "p",
        "children": [
          {
            "tag": "strong",
            "children": [
              {
                "text": "不動産価格:",
              },
            ],
          },
          {
            "text": " 不動産価格全体が高騰している局面か、下落している局面かを見極めます。",
          },
        ],
      },
      {
        "tag": "aside",
        "role": "product",
        "children": [
          {
            "tag": "strong",
            "children": [
              {
                "text": "プロパリー活用ポイント",
              },
            ],
          },
          {
            "tag": "p",
            "children": [
              {
                "tag": "strong",
                "children": [
                  {
                    "text": "市況の把握:",
                  },
                ],
              },
              {
                "text": " プロパリーの「",
              },
              {
                "tag": "strong",
                "children": [
                  {
                    "text": "成約事例検索",
                  },
                ],
              },
              {
                "text": "」機能で、ご自身の物件エリアの相場（いくらで売れているか）を定期的にチェックし、マーケットの温度感を把握しましょう。",
              },
            ],
          },
        ],
      },
      {
        "tag": "aside",
        "role": "summary",
        "children": [
          {
            "tag": "strong",
            "children": [
              {
                "text": "学習ポイントまとめ",
              },
            ],
          },
          {
            "tag": "p",
            "children": [
              {
                "text": "最適な売却タイミングとは、「①所有期間5年を超え（税率減）」「②CF悪化（デッドクロス等）の直前」「③市況が良好（低金利・価格高騰）」という3つの要素が重なった時である。",
              },
            ],
          },
          {
            "tag": "p",
            "children": [
              {
                "text": "これらを無視して感覚で売却すると、手元に残る利益が大きく減る可能性がある。",
              },
            ],
          },
        ],
      },
      {
        "tag": "p",
        "children": [
          {
            "text": " 売却する「タイミング」を決めたら、次は「どう売るか？」という具体的な「方法」です。 「仲介売却」と「買取」の違いと、それぞれのメリット・デメリットについて学びましょう。",
          },
        ],
      },
      {
        "tag": "hr",
        "children": [],
      },
    ],
  },
  "advanced-5": {
    "sourceUrl": "https://propally.co.jp/journal/lp/advanced-5/",
    "sourceTitle": "「2棟目、3棟目」を買うための融資拡大戦略",
    "acquiredAt": "2026-10-05T07:21:41.682Z",
    "sourceTextSha256": "d702d9370ea0142995b9b084d6b385d23be9b49df589c435f88a777486c63381",
    "nodes": [
      {
        "tag": "p",
        "children": [
          {
            "text": "1棟目の購入に成功した投資家が、次に目指すのが「2棟目、3棟目」の買い増しによる規模の拡大です。 しかし、2棟目の融資審査は、1棟目よりもハードルが上がることがあります。金融機関は、あなたの「属性」に加えて、もう一つの重要な項目を審査するからです。",
          },
        ],
      },
      {
        "tag": "p",
        "children": [
          {
            "text": "それは",
          },
          {
            "text": "「",
          },
          {
            "tag": "strong",
            "children": [
              {
                "text": "1棟目の大家（オーナー）としての経営実績",
              },
            ],
          },
          {
            "text": "」",
          },
          {
            "text": "です。",
          },
        ],
      },
      {
        "tag": "aside",
        "role": "learn",
        "children": [
          {
            "tag": "strong",
            "children": [
              {
                "text": "学習目標",
              },
            ],
          },
          {
            "tag": "ul",
            "children": [
              {
                "tag": "li",
                "children": [
                  {
                    "text": "2棟目以降の融資審査が、1棟目と「何が違うか」を理解する。",
                  },
                ],
              },
              {
                "tag": "li",
                "children": [
                  {
                    "text": "「金融機関の開拓」と「ポートフォリオ」という事業拡大に必要な2つの戦略を学ぶ。",
                  },
                ],
              },
              {
                "tag": "li",
                "children": [
                  {
                    "text": "ご自身の「与信枠（融資の上限）」を意識した物件選びができるようになる。",
                  },
                ],
              },
            ],
          },
        ],
      },
      {
        "tag": "h3",
        "children": [
          {
            "tag": "strong",
            "children": [
              {
                "text": "1. 金融機関は「1棟目の経営実績」を見る",
              },
            ],
          },
        ],
      },
      {
        "tag": "p",
        "children": [
          {
            "tag": "strong",
            "children": [
              {
                "text": "見られる点:",
              },
            ],
          },
        ],
      },
      {
        "tag": "p",
        "children": [
          {
            "text": "1棟目の物件は、想定通りに家賃収入を生んでいますか？（空室が常態化していないか）",
          },
        ],
      },
      {
        "tag": "p",
        "children": [
          {
            "text": "収支管理はしっかり行われていますか？（確定申告書、物件概要書、レントロール（家賃台帳）の提出を求められます）",
          },
        ],
      },
      {
        "tag": "p",
        "children": [
          {
            "text": "ローンの返済は一度も遅延していませんか？",
          },
        ],
      },
      {
        "tag": "p",
        "children": [
          {
            "tag": "strong",
            "children": [
              {
                "text": "ポイント:",
              },
            ],
          },
          {
            "tag": "br",
            "children": [],
          },
          {
            "text": "1棟目の運営が赤字だったり、収支資料をずさんに管理していたりすると、「この人に2棟目を任せても失敗するだろう」と判断され、融資は非常に厳しくなります。",
          },
        ],
      },
      {
        "tag": "h3",
        "children": [
          {
            "tag": "strong",
            "children": [
              {
                "tag": "strong",
                "children": [
                  {
                    "text": "2. 戦略①：金融機関の「新規開拓」",
                  },
                ],
              },
            ],
          },
        ],
      },
      {
        "tag": "p",
        "children": [
          {
            "text": "1棟目で融資してくれた金融機関が、2棟目もOKしてくれるとは限りません。",
          },
        ],
      },
      {
        "tag": "p",
        "children": [
          {
            "text": "金融機関には「A銀行はアパートローンに積極的」「B信用金庫は地元の物件にしか貸さない」といった得意分野や方針があります。 1棟目の実績（＝クリーンな収支と返済実績）を「お土産」として、1棟目とは異なる金融機関（信金、信組、地銀、公庫など）とも新たに取引を開始し、融資の「窓口」を広げていく戦略が重要です。",
          },
        ],
      },
      {
        "tag": "h3",
        "children": [
          {
            "tag": "strong",
            "children": [
              {
                "tag": "strong",
                "children": [
                  {
                    "text": "3. 戦略②：「与信枠」を意識した物件選び",
                  },
                ],
              },
            ],
          },
        ],
      },
      {
        "tag": "p",
        "children": [
          {
            "tag": "strong",
            "children": [
              {
                "text": "「与信枠」",
              },
            ],
          },
          {
            "text": "とは、金融機関が「あなた個人に、トータルでいくらまでなら貸せるか」という上限額のことです。",
          },
        ],
      },
      {
        "tag": "p",
        "children": [
          {
            "tag": "strong",
            "children": [
              {
                "text": "ポイント:",
              },
            ],
          },
          {
            "tag": "br",
            "children": [],
          },
          {
            "text": "あなたの与信枠は",
          },
          {
            "tag": "strong",
            "children": [
              {
                "text": "「有限な資源」",
              },
            ],
          },
          {
            "text": "です。その貴重な与信枠を使って、どの物件（＝ポートフォリオ）を買うべきか、常に総資産のバランスを考える必要があります。",
          },
        ],
      },
      {
        "tag": "p",
        "children": [
          {
            "tag": "strong",
            "children": [
              {
                "text": "失敗例:",
              },
            ],
          },
          {
            "tag": "br",
            "children": [],
          },
          {
            "text": "1棟目に、自己資金と与信枠の多くを使い、地方の低利回り物件を買ってしまう。",
          },
          {
            "tag": "br",
            "children": [],
          },
          {
            "text": "結果として、本当に優良な2棟目（高利回りの都心物件など）が出てきた時に、与信枠が残っておらず、融資が受けられない（＝事業拡大がストップする）。",
          },
        ],
      },
      {
        "tag": "aside",
        "role": "summary",
        "children": [
          {
            "tag": "strong",
            "children": [
              {
                "text": "学習ポイントまとめ",
              },
            ],
          },
          {
            "tag": "p",
            "children": [
              {
                "text": "2棟目の融資は、",
              },
              {
                "tag": "strong",
                "children": [
                  {
                    "text": "「個人の属性」＋「1棟目の経営実績」",
                  },
                ],
              },
              {
                "text": "で判断される。",
              },
            ],
          },
          {
            "tag": "p",
            "children": [
              {
                "tag": "strong",
                "children": [
                  {
                    "text": "1棟目の収支管理（確定申告）",
                  },
                ],
              },
              {
                "text": "こそが、2棟目への最大の武器である。",
              },
            ],
          },
          {
            "tag": "p",
            "children": [
              {
                "text": "融資の「窓口」は、1つの銀行に依存せず、常に新規開拓を続ける。",
              },
            ],
          },
          {
            "tag": "p",
            "children": [
              {
                "text": "あなたの",
              },
              {
                "tag": "strong",
                "children": [
                  {
                    "text": "「与信枠（貸してもらえる上限）」は有限",
                  },
                ],
              },
              {
                "text": "である。その枠をどの物件に使うか、戦略的に判断する。",
              },
            ],
          },
        ],
      },
      {
        "tag": "p",
        "children": [
          {
            "text": "2棟、3棟と規模が拡大し、個人の所得（利益）が増えてくると、次は「税金」が大きな壁となって立ちはだかります。 その壁を越えるための上級テクニック、「資産管理法人」の設立について学びましょう。",
          },
        ],
      },
      {
        "tag": "hr",
        "children": [],
      },
    ],
  },
  "advanced-6": {
    "sourceUrl": "https://propally.co.jp/journal/lp/advanced-6/",
    "sourceTitle": "「資産管理法人」設立のメリット・デメリットと最適タイミング",
    "acquiredAt": "2026-10-05T07:21:41.622Z",
    "sourceTextSha256": "09bc0870edb947ccffd40308235c00f0d7e29e06abd1e7fbdcd4e71ee0800a6b",
    "nodes": [
      {
        "tag": "p",
        "children": [
          {
            "text": "2棟、3棟と買い進め、不動産所得（利益）が大きくなってくると、個人の「所得税」の負担が急激に重くなります。 個人の所得税は「累進課税」で、所得が増えるほど税率が上がり、最大で",
          },
          {
            "tag": "strong",
            "children": [
              {
                "text": "約55%",
              },
            ],
          },
          {
            "text": "（住民税含む）にも達します。",
          },
        ],
      },
      {
        "tag": "p",
        "children": [
          {
            "text": "この「税金の壁」を越えるための戦略が、「",
          },
          {
            "tag": "strong",
            "children": [
              {
                "text": "資産管理法人（法人化）",
              },
            ],
          },
          {
            "text": "」です。",
          },
        ],
      },
      {
        "tag": "aside",
        "role": "learn",
        "children": [
          {
            "tag": "strong",
            "children": [
              {
                "text": "学習目標",
              },
            ],
          },
          {
            "tag": "ul",
            "children": [
              {
                "tag": "li",
                "children": [
                  {
                    "text": "なぜ「法人化」するのか、その最大の理由（節税）を理解する。",
                  },
                ],
              },
              {
                "tag": "li",
                "children": [
                  {
                    "text": "法人化のメリットと、見落としがちなデメリット（コスト・手間）を天秤にかけて判断できるようになる。",
                  },
                ],
              },
              {
                "tag": "li",
                "children": [
                  {
                    "text": "ご自身が法人化を検討すべき「最適タイミング」の目安を知る。",
                  },
                ],
              },
            ],
          },
        ],
      },
      {
        "tag": "h3",
        "children": [
          {
            "tag": "strong",
            "children": [
              {
                "text": "1. 法人化の「メリット」",
              },
            ],
          },
        ],
      },
      {
        "tag": "p",
        "children": [
          {
            "tag": "strong",
            "children": [
              {
                "text": "① 節税（税率の差）",
              },
            ],
          },
          {
            "tag": "br",
            "children": [],
          },
          {
            "text": "これが最大の目的です。法人の実効税率は、利益の大きさにもよりますが**約25%〜35%**程度で、個人の最高税率（約55%）より大幅に低くなります。",
          },
        ],
      },
      {
        "tag": "p",
        "children": [
          {
            "tag": "strong",
            "children": [
              {
                "text": "② 損益通算の拡大",
              },
            ],
          },
          {
            "tag": "br",
            "children": [],
          },
          {
            "text": "（青色申告法人の場合）不動産投資で赤字が出た場合、その赤字を",
          },
          {
            "tag": "strong",
            "children": [
              {
                "text": "最大10年間",
              },
            ],
          },
          {
            "text": "繰り越すことができます。個人（青色申告）の3年間より長く、将来の黒字と相殺できます。",
          },
        ],
      },
      {
        "tag": "p",
        "children": [
          {
            "tag": "strong",
            "children": [
              {
                "text": "③ 経費計上の範囲拡大",
              },
            ],
          },
          {
            "tag": "br",
            "children": [],
          },
          {
            "text": "ご自身（オーナー）や家族を法人の「役員」とし、",
          },
          {
            "tag": "strong",
            "children": [
              {
                "text": "役員報酬",
              },
            ],
          },
          {
            "text": "を支払うことができます。この役員報酬は法人の「経費」として計上でき、さらに役員側では「給与所得控除」が使えるため、個人で利益をそのまま受け取るより税負担が軽くなります。 また、生命保険料や退職金なども経費として計上しやすくなります。",
          },
        ],
      },
      {
        "tag": "p",
        "children": [
          {
            "tag": "strong",
            "children": [
              {
                "text": "④ 融資枠の拡大",
              },
            ],
          },
          {
            "tag": "br",
            "children": [],
          },
          {
            "text": "個人としての「与信枠」とは別に、「法人」としての与信枠で融資を受けられる可能性があります。金融機関によっては、法人でなければ取引しないケースもあり、規模拡大に有利に働くことがあります。",
          },
        ],
      },
      {
        "tag": "h3",
        "children": [
          {
            "tag": "strong",
            "children": [
              {
                "tag": "strong",
                "children": [
                  {
                    "text": "2. 法人化の「デメリット（コスト・手間）」",
                  },
                ],
              },
            ],
          },
        ],
      },
      {
        "tag": "p",
        "children": [
          {
            "tag": "strong",
            "children": [
              {
                "text": "① 設立・維持コスト",
              },
            ],
          },
          {
            "tag": "br",
            "children": [],
          },
          {
            "text": "法人の設立費用（登録免許税、司法書士報酬など）で数十万円がかかります。 また、利益がゼロ（赤字）でも、毎年必ず「",
          },
          {
            "tag": "strong",
            "children": [
              {
                "text": "法人住民税の均等割",
              },
            ],
          },
          {
            "text": "」（最低でも約7万円〜）を納付しなければなりません。",
          },
        ],
      },
      {
        "tag": "p",
        "children": [
          {
            "tag": "strong",
            "children": [
              {
                "text": "② 税務処理の複雑化",
              },
            ],
          },
          {
            "tag": "br",
            "children": [],
          },
          {
            "text": "法人の税務申告（決算）は非常に複雑なため、",
          },
          {
            "tag": "strong",
            "children": [
              {
                "text": "税理士との顧問契約が必須",
              },
            ],
          },
          {
            "text": "となり、その費用（年間数十万円〜）が固定費として発生します。",
          },
        ],
      },
      {
        "tag": "p",
        "children": [
          {
            "tag": "strong",
            "children": [
              {
                "text": "③ 資金の（短期的な）非流動性:",
              },
            ],
          },
          {
            "text": " 法人が得た利益（家賃収入）は、法人のものです。オーナー個人が自由に使うことはできず、「役員報酬」として計画的に受け取る必要があります。",
          },
        ],
      },
      {
        "tag": "h3",
        "children": [
          {
            "tag": "strong",
            "children": [
              {
                "tag": "strong",
                "children": [
                  {
                    "tag": "strong",
                    "children": [
                      {
                        "text": "3. 法人化を検討すべき「最適タイミング」は？",
                      },
                    ],
                  },
                ],
              },
            ],
          },
        ],
      },
      {
        "tag": "p",
        "children": [
          {
            "text": "一概には言えませんが、専門家の間では以下の2つが目安とされることが多いです。",
          },
        ],
      },
      {
        "tag": "p",
        "children": [
          {
            "tag": "strong",
            "children": [
              {
                "text": "目安①",
              },
            ],
          },
          {
            "tag": "br",
            "children": [],
          },
          {
            "tag": "strong",
            "children": [
              {
                "text": "不動産所得（課税所得）が「900万円」を超えたら",
              },
            ],
          },
          {
            "text": " 個人の所得税率は、課税所得900万円を超えると33%（+住民税10% = 43%）となり、法人の実効税率（約30%台）との差が明確に出てくるためです。",
          },
        ],
      },
      {
        "tag": "p",
        "children": [
          {
            "tag": "strong",
            "children": [
              {
                "text": "目安②",
              },
            ],
          },
          {
            "tag": "br",
            "children": [],
          },
          {
            "tag": "strong",
            "children": [
              {
                "text": "融資戦略として、金融機関から求められたら",
              },
            ],
          },
          {
            "text": " 2棟目、3棟目の融資を受ける際、金融機関側から「法人格がないと融資は難しい」と要求されるケースがあります。この場合は、節税目的ではなく「規模拡大」のために法人化を判断します。",
          },
        ],
      },
      {
        "tag": "aside",
        "role": "summary",
        "children": [
          {
            "tag": "strong",
            "children": [
              {
                "text": "学習ポイントまとめ",
              },
            ],
          },
          {
            "tag": "p",
            "children": [
              {
                "text": "法人化の最大の目的は、",
              },
              {
                "tag": "strong",
                "children": [
                  {
                    "text": "個人の「累進課税（最大約55%）」から、法人の「固定税率（約30%台）」へ移行することによる「節税」",
                  },
                ],
              },
              {
                "text": "。",
              },
            ],
          },
          {
            "tag": "p",
            "children": [
              {
                "text": "ただし、",
              },
              {
                "tag": "strong",
                "children": [
                  {
                    "text": "「法人維持コスト（税理士費用、均等割）」が毎年必ず発生するデメリット",
                  },
                ],
              },
              {
                "text": "もある。",
              },
            ],
          },
          {
            "tag": "p",
            "children": [
              {
                "text": "節税メリットが維持コストを上回る",
              },
              {
                "tag": "strong",
                "children": [
                  {
                    "text": "「不動産所得900万円」",
                  },
                ],
              },
              {
                "text": "が、法人化を検討する一つの目安となる。",
              },
            ],
          },
        ],
      },
      {
        "tag": "p",
        "children": [
          {
            "text": "個人であれ法人であれ、投資規模が大きくなればなるほど「収支の正確な管理」と「確定申告」の重要性が増します。 次は、複数の物件の収支を一元管理し、確定申告の手間を削減する方法について学びましょう。",
          },
        ],
      },
      {
        "tag": "hr",
        "children": [],
      },
    ],
  },
  "advanced-7": {
    "sourceUrl": "https://propally.co.jp/journal/lp/advanced-7/",
    "sourceTitle": "収支の一元管理と「確定申告」の効率化",
    "acquiredAt": "2026-10-05T07:21:41.792Z",
    "sourceTextSha256": "a732d60c2ee826c1501cfc9f58259ab2967345cf6425444cf23cb657f74e9387",
    "nodes": [
      {
        "tag": "p",
        "children": [
          {
            "text": "物件数が1棟（1部屋）であれば、Excelや家計簿アプリでの管理でも対応できるかもしれません。 しかし、2棟、3棟と物件が増え、取引する管理会社や金融機関が複数になると、その管理業務は一気に複雑化します。",
          },
        ],
      },
      {
        "tag": "aside",
        "role": "learn",
        "children": [
          {
            "tag": "strong",
            "children": [
              {
                "text": "学習目標",
              },
            ],
          },
          {
            "tag": "ul",
            "children": [
              {
                "tag": "li",
                "children": [
                  {
                    "text": "複数物件の収支管理（Excelなど）の限界と、管理を怠るリスク（税務・融資）を理解する。",
                  },
                ],
              },
              {
                "tag": "li",
                "children": [
                  {
                    "text": "「確定申告」に必要な書類（領収書・契約書など）を、いかに日頃から効率的に整理・保存するかを学ぶ。",
                  },
                ],
              },
            ],
          },
        ],
      },
      {
        "tag": "h3",
        "children": [
          {
            "tag": "strong",
            "children": [
              {
                "text": "規模拡大で直面する「管理の壁」",
              },
            ],
          },
        ],
      },
      {
        "tag": "p",
        "children": [
          {
            "tag": "strong",
            "children": [
              {
                "text": "Excel管理の限界",
              },
            ],
          },
          {
            "tag": "br",
            "children": [],
          },
          {
            "text": "物件ごと、月ごと、費目ごと（家賃、ローン、修繕費、税金…）にシートが分散。ポートフォリオ（資産全体）の収支が瞬時に把握できなくなる。",
          },
        ],
      },
      {
        "tag": "p",
        "children": [
          {
            "tag": "strong",
            "children": [
              {
                "text": "書類の氾濫",
              },
            ],
          },
          {
            "tag": "br",
            "children": [],
          },
          {
            "text": "物件Aの賃貸借契約書、物件Bのローン返済予定表、物件Cの修繕費の領収書…といった紙の書類が物理的に氾濫し、必要な時に見つからなくなる。",
          },
        ],
      },
      {
        "tag": "p",
        "children": [
          {
            "tag": "strong",
            "children": [
              {
                "text": "確定申告時の地獄",
              },
            ],
          },
          {
            "tag": "br",
            "children": [],
          },
          {
            "text": "年に一度、税理士に提出するために、1年分の銀行通帳のコピー、すべての領収書、管理会社からの収支報告書をかき集める作業に、丸一日（あるいは数日）を費やすことになる。",
          },
        ],
      },
      {
        "tag": "h3",
        "children": [
          {
            "tag": "strong",
            "children": [
              {
                "tag": "strong",
                "children": [
                  {
                    "text": "なぜ「ずさんな管理」が危険なのか？",
                  },
                ],
              },
            ],
          },
        ],
      },
      {
        "tag": "p",
        "children": [
          {
            "tag": "strong",
            "children": [
              {
                "text": "税務リスク",
              },
            ],
          },
          {
            "tag": "br",
            "children": [],
          },
          {
            "text": "経費（領収書）の計上漏れが発生し、本来払う必要のない税金を払ってしまう。最悪の場合、税務調査で書類不備を指摘され、追徴課税のリスクもある。",
          },
        ],
      },
      {
        "tag": "p",
        "children": [
          {
            "tag": "strong",
            "children": [
              {
                "text": "融資戦略リスク",
              },
            ],
          },
          {
            "tag": "br",
            "children": [],
          },
          {
            "text": "2棟目、3棟目の融資（規模拡大）を申し込む際、金融機関から「物件の収支実績（レントロールや確定申告書）」の提出を求められます。その資料を迅速かつ正確に提出できないと、「この人は経営管理ができない」と判断され、融資を断られます。",
          },
        ],
      },
      {
        "tag": "h3",
        "children": [
          {
            "tag": "strong",
            "children": [
              {
                "tag": "strong",
                "children": [
                  {
                    "tag": "strong",
                    "children": [
                      {
                        "text": "管理業務を「仕組み化」する",
                      },
                    ],
                  },
                ],
              },
            ],
          },
        ],
      },
      {
        "tag": "p",
        "children": [
          {
            "text": "これらの業務は「年に一度」やるのではなく、「毎月」行うべきです。 管理会社から家賃が振り込まれ、収支報告書が届いた「その日」に、収支を記録し、関連書類（PDFや画像）を保存するクセをつけましょう。",
          },
        ],
      },
      {
        "tag": "aside",
        "role": "product",
        "children": [
          {
            "tag": "strong",
            "children": [
              {
                "text": "プロパリー活用ポイント",
              },
            ],
          },
          {
            "tag": "p",
            "children": [
              {
                "text": "プロパリーの「",
              },
              {
                "tag": "strong",
                "children": [
                  {
                    "text": "不動産管理（保有物件）機能",
                  },
                ],
              },
              {
                "text": "」は、この「",
              },
              {
                "tag": "strong",
                "children": [
                  {
                    "text": "収支の一元管理",
                  },
                ],
              },
              {
                "text": "」と「",
              },
              {
                "tag": "strong",
                "children": [
                  {
                    "text": "書類の電子保存",
                  },
                ],
              },
              {
                "text": "」のために設計されています。",
              },
            ],
          },
          {
            "tag": "p",
            "children": [
              {
                "text": "物件ごとに、毎月の家賃収入、管理手数料、ローン返済、修繕費などをアプリに入力するだけで、",
              },
              {
                "tag": "strong",
                "children": [
                  {
                    "text": "ポートフォリオ全体のキャッシュフローが自動でグラフ化",
                  },
                ],
              },
              {
                "text": "されます。",
              },
            ],
          },
          {
            "tag": "p",
            "children": [
              {
                "text": "さらに、管理会社からの収支報告書（PDF）や、修繕時の領収書（写真）、賃貸借契約書などを、物件に紐づけて",
              },
              {
                "tag": "strong",
                "children": [
                  {
                    "text": "電子データとしてアプリに保存",
                  },
                ],
              },
              {
                "text": "できます。",
              },
            ],
          },
          {
            "tag": "p",
            "children": [
              {
                "text": "これにより、確定申告の時期に慌てて紙の書類を探す必要がなくなり、税理士へのデータ共有もスムーズになります。",
              },
            ],
          },
        ],
      },
      {
        "tag": "aside",
        "role": "summary",
        "children": [
          {
            "tag": "strong",
            "children": [
              {
                "text": "学習ポイントまとめ",
              },
            ],
          },
          {
            "tag": "p",
            "children": [
              {
                "text": "投資規模の拡大は、",
              },
              {
                "tag": "strong",
                "children": [
                  {
                    "text": "「管理業務の増大」と表裏一体",
                  },
                ],
              },
              {
                "text": "である。",
              },
            ],
          },
          {
            "tag": "p",
            "children": [
              {
                "tag": "strong",
                "children": [
                  {
                    "text": "「収支管理」と「書類保存」を日頃から仕組み化（デジタル化）すること",
                  },
                ],
              },
              {
                "text": "が、節税と融資戦略（＝さらなる規模拡大）の土台となる。",
              },
            ],
          },
          {
            "tag": "p",
            "children": [
              {
                "text": "確定申告は「年に一度のイベント」ではなく、",
              },
              {
                "tag": "strong",
                "children": [
                  {
                    "text": "「毎月のデータ入力の結果」",
                  },
                ],
              },
              {
                "text": "である。",
              },
            ],
          },
        ],
      },
      {
        "tag": "p",
        "children": [
          {
            "text": "お疲れさまでした！ これで上級編で学ぶべき「保有物件の運営と拡大」スキルはすべて完了です。 最後に、これまで学んだ知識（特に売却戦略）を総動員して行う「売却シミュレーション」の具体的な活用術を、番外編として学びましょう。",
          },
        ],
      },
      {
        "tag": "hr",
        "children": [],
      },
    ],
  },
  "advanced-8": {
    "sourceUrl": "https://propally.co.jp/journal/lp/advanced-8/",
    "sourceTitle": "番外編：プロパリー　シミュレーション徹底活用術（売却編）",
    "acquiredAt": "2026-10-05T07:21:41.797Z",
    "sourceTextSha256": "b59885fe160aa347dc96c7d727c794dead9d0ac8e4fc277a12ad4504b918e9a1",
    "nodes": [
      {
        "tag": "p",
        "children": [
          {
            "text": "お疲れさまでした。上級編では、空室対策から法人化、収支管理まで、保有物件の「収益最大化」と「事業拡大」の戦略を学んできました。",
          },
        ],
      },
      {
        "tag": "p",
        "children": [
          {
            "text": "最後は、これらの戦略の「集大成」です。 Propallyのシミュレーション機能は「買う時」だけのものではありません。むしろ、「",
          },
          {
            "tag": "strong",
            "children": [
              {
                "text": "いつ売れば、手取りが最大になるか？",
              },
            ],
          },
          {
            "text": "」を予測する、出口戦略のための最強のツールです。",
          },
        ],
      },
      {
        "tag": "aside",
        "role": "learn",
        "children": [
          {
            "tag": "strong",
            "children": [
              {
                "text": "学習目標",
              },
            ],
          },
          {
            "tag": "ul",
            "children": [
              {
                "tag": "li",
                "children": [
                  {
                    "text": "購入時のシミュレーションを「出口戦略（売却）」の立案ツールとして活用し直す方法を学ぶ。",
                  },
                ],
              },
              {
                "tag": "li",
                "children": [
                  {
                    "text": "「売却時手取り額」の最大化を目的とし、「税金（譲渡所得税）」と「ローン残高」の変化をシミュレーションする重要性を理解する。",
                  },
                ],
              },
            ],
          },
        ],
      },
      {
        "tag": "h3",
        "children": [
          {
            "tag": "strong",
            "children": [
              {
                "text": "「売却時手取り額」の構成要素とは？",
              },
            ],
          },
        ],
      },
      {
        "tag": "p",
        "children": [
          {
            "text": "投資家が最終的に手にするのは、以下の計算式で決まります。 ",
          },
        ],
      },
      {
        "tag": "p",
        "children": [
          {
            "tag": "strong",
            "children": [
              {
                "text": "売却時手取り額 ＝ 売却価格 －（①諸経費 ＋ ②ローン残高 ＋ ③譲渡所得税）",
              },
            ],
          },
        ],
        "role": "formula",
      },
      {
        "tag": "p",
        "children": [
          {
            "text": "このうち、②と③は「時間」と共に大きく変動します。",
          },
        ],
      },
      {
        "tag": "p",
        "children": [
          {
            "tag": "strong",
            "children": [
              {
                "text": "③譲渡所得税",
              },
            ],
          },
          {
            "tag": "br",
            "children": [],
          },
          {
            "text": "上級編で学んだ通り、",
          },
          {
            "tag": "strong",
            "children": [
              {
                "text": "所有期間が5年を超えるかどうか",
              },
            ],
          },
          {
            "text": "（短期譲渡と長期譲渡）で税率が「",
          },
          {
            "tag": "strong",
            "children": [
              {
                "text": "約39.6%",
              },
            ],
          },
          {
            "text": "」から「",
          },
          {
            "tag": "strong",
            "children": [
              {
                "text": "約20.3%",
              },
            ],
          },
          {
            "text": "」に激減します。これは手取り額に最も大きなインパクトを与える変数です。",
          },
        ],
      },
      {
        "tag": "p",
        "children": [
          {
            "tag": "strong",
            "children": [
              {
                "text": "②ローン残高",
              },
            ],
          },
          {
            "tag": "br",
            "children": [],
          },
          {
            "text": "返済が進めば、当然ながら残高は減っていきます。",
          },
        ],
      },
      {
        "tag": "aside",
        "role": "product",
        "children": [
          {
            "tag": "strong",
            "children": [
              {
                "text": "プロパリー活用ポイント",
              },
            ],
          },
          {
            "tag": "p",
            "children": [
              {
                "text": "「今すぐ売る」のがベストとは限りません。プロパリーのシミュレーション機能（保有物件の管理画面からも利用可能）を使い、複数の「もしも」をテストしましょう。",
              },
            ],
          },
          {
            "tag": "p",
            "children": [
              {
                "text": "キャッシュフローが悪化する「直前」を売却タイミングの候補とし、その際の手取り額がいくらになるかを試算します。",
              },
            ],
          },
          {
            "tag": "aside",
            "role": "learn",
            "children": [
              {
                "tag": "strong",
                "children": [
                  {
                    "text": "テスト①：「5年の壁」を越える",
                  },
                ],
              },
              {
                "tag": "p",
                "children": [
                  {
                    "tag": "strong",
                    "children": [
                      {
                        "text": "「4年後に売却した場合」",
                      },
                    ],
                  },
                  {
                    "text": "（短期譲渡＝税率39.6%）",
                  },
                ],
              },
              {
                "tag": "p",
                "children": [
                  {
                    "tag": "strong",
                    "children": [
                      {
                        "text": "「6年後に売却した場合」",
                      },
                    ],
                  },
                  {
                    "text": "（長期譲渡＝税率20.3%）",
                  },
                ],
              },
              {
                "tag": "p",
                "children": [
                  {
                    "text": "上記2パターンで、",
                  },
                  {
                    "tag": "strong",
                    "children": [
                      {
                        "text": "売却時手取り額",
                      },
                    ],
                  },
                  {
                    "text": "を試算します。6年後の方が売却価格が多少下がったとしても、税率のインパクトが大きすぎて、6年後に売った方が手取り額が圧倒的に多くなるケースがほとんどです。",
                  },
                ],
              },
            ],
          },
          {
            "tag": "aside",
            "role": "learn",
            "children": [
              {
                "tag": "strong",
                "children": [
                  {
                    "tag": "strong",
                    "children": [
                      {
                        "text": "テスト②：ローン残高とのバランス",
                      },
                    ],
                  },
                ],
              },
              {
                "tag": "p",
                "children": [
                  {
                    "text": "ローン返済（元金）が進むスピードと、建物の減価償却（帳簿価額）が減少するスピードをシミュレーションします。",
                  },
                ],
              },
              {
                "tag": "p",
                "children": [
                  {
                    "text": "これにより、売却益（譲渡所得）がいくらになるかを予測し、税額を算出できます。",
                  },
                ],
              },
            ],
          },
          {
            "tag": "aside",
            "role": "learn",
            "children": [
              {
                "tag": "strong",
                "children": [
                  {
                    "tag": "strong",
                    "children": [
                      {
                        "tag": "strong",
                        "children": [
                          {
                            "text": "テスト③：デッドクロスからの逆算",
                          },
                        ],
                      },
                    ],
                  },
                ],
              },
              {
                "tag": "p",
                "children": [
                  {
                    "text": "中級編で学んだ「デッドクロス」が発生する時期をシミュレーションで特定します。",
                  },
                ],
              },
            ],
          },
        ],
      },
      {
        "tag": "aside",
        "role": "summary",
        "children": [
          {
            "tag": "strong",
            "children": [
              {
                "text": "学習ポイントまとめ",
              },
            ],
          },
          {
            "tag": "p",
            "children": [
              {
                "text": "シミュレーションは",
              },
              {
                "tag": "strong",
                "children": [
                  {
                    "text": "「買う時」",
                  },
                ],
              },
              {
                "text": "だけでなく",
              },
              {
                "tag": "strong",
                "children": [
                  {
                    "text": "、「いつ売るか」",
                  },
                ],
              },
              {
                "text": "という出口戦略を立案するためにこそ使うべきツールである。",
              },
            ],
          },
          {
            "tag": "p",
            "children": [
              {
                "text": "「売却価格」だけを追うのではなく、「ローン残高」と「税率（特に5年の壁）」を考慮した「売却時手取り額」が最大になるタイミングを探すことが重要。",
              },
            ],
          },
          {
            "tag": "p",
            "children": [
              {
                "text": "優れた投資家は、感覚で売らない。",
              },
              {
                "tag": "strong",
                "children": [
                  {
                    "text": "必ず「シミュレーション」で複数の売却シナリオをテストし、最も合理的な出口を選択する",
                  },
                ],
              },
              {
                "text": "。",
              },
            ],
          },
        ],
      },
      {
        "tag": "p",
        "children": [
          {
            "text": "おめでとうございます！ これで「プロパリースタディライブラリー」のすべての課程が修了です。 あなたは、不動産投資の基礎から、実践的な購入スキル、そしてプロの運営戦略まで、体系的な知識を身につけました。",
          },
        ],
      },
      {
        "tag": "p",
        "children": [
          {
            "text": "しかし、本当のスタートはこれからです。 学んだ知識を「実践」で使いこなし、Propallyの全機能（シミュレーション、管理、オファー、事例検索）を駆使して、あなたの「収益最大化」を実現してください。",
          },
        ],
      },
      {
        "tag": "hr",
        "children": [],
      },
    ],
  },
};
